export const Genders = [
  {
    key: "male",
    text: "Male"
  },
  {
    key: "female",
    text: "Female"
  }
];

export const Gender = [
  { key: "male", text: "Male" },
  { key: "female", text: "Female" }
];
export const VenueType = [
  { key: "physical", text: "Physical" },
  { key: "virtual", text: "Virtual" }
];
export const LibraryItemType = [
  { key: "book", text: "Book" },
  { key: "video", text: "Video" }
];
export const AllowedScopes = [
  // { name: "access_control", text: "Access Control" },
  // { name: "assessments", text: "Assessments" },
  // { name: "assignments", text: "Assignments" },
  // { name: "bookmarks", text: "Bookmarks" },
  // { name: "ca_test", text: "CA Test" },
  // { name: "ca_test_result", text: "CA Test Result" },
  // { name: "classes", text: "Classes" },
  // { name: "contractors", text: "Contractors" },
  // { name: "custom_report_subjects", text: "Custom Report Subjects" },
  // { name: "custom_reports", text: "Custom Reports" },
  // { name: "departments", text: "Departments" },
  // { name: "employee_profile", text: "Employee Profile" },
  // { name: "enrolment_custom_forms", text: "Enrolment Custom Forms" },
  // { name: "enrolment_exam_attachment", text: "Enrolment Exam Attachment" },
  // { name: "enrolments", text: "Enrolments" },
  // { name: "events", text: "Events" },
  // { name: "inventories", text: "Inventories" },
  // { name: "inventory_categories", text: "Inventory Categories" },
  // { name: "knowledge_base", text: "Knowledge Base" },
  // { name: "leave_management", text: "Leave Management" },
  // { name: "leave_options", text: "Leave Options" },
  // { name: "lesson_notes", text: "Lesson Notes" },
  { name: "lesson_outlines", text: "Lesson Outlines" },
  { name: "school_profile", text: "School Profile" }
  // { name: "library", text: "Library" },
  // { name: "notice_board", text: "Notice Board" },
  // { name: "obtainable_score", text: "Obtainable Score" },
  // { name: "period", text: "Period" },
  // { name: "procurements", text: "Procurements" },
  // { name: "school_exam", text: "School Exam" },
  // { name: "school_plans", text: "School Plans" },
  // { name: "school_report_extras", text: "School Report Extras" },
  // { name: "sessions", text: "Sessions" },
  // { name: "student_assignment", text: "Student Assignment" },
  // { name: "student_attendance", text: "Student Attendance" },
  // { name: "student_custom_reports", text: "Student Custom Reports" },
  // { name: "student_exam_cache", text: "Student Exam Cache" },
  // { name: "student_exam_result", text: "Student Exam Result" },
  // { name: "student_invoice", text: "Student Invoice" },
  // { name: "student_leave_requests", text: "Student Leave Requests" },
  // { name: "student_reports", text: "Student Reports" },
  // { name: "students", text: "Students" },
  // { name: "subjects", text: "Subjects" },
  // { name: "syllabus", text: "Syllabus" },
  // { name: "terms", text: "Terms" }
];
export const InventoryCondition = [
  { key: "new", text: "New" },
  { key: "used", text: "Used" },
  { key: "fair", text: "Fair" },
  { key: "good", text: "Good" },
  { key: "poor", text: "Poor" },
  { key: "damaged", text: "Damaged" },
  { key: "others", text: "Others" }
];

export const Currency = [
  { key: "book", text: "Book" },
  { key: "video", text: "Video" }
];

export const ItemSample = [
  { key: "item-one", text: "Item 1" },
  { key: "item-two", text: "Item 2" },
  { key: "item-three", text: "Item 3" }
];

export const PaymentType = [
  { key: "paystack", text: "Paystack" },
  { key: "flutterwave", text: "Flutterwave" },
  { key: "stripe", text: "Stripe" }
];

export const CurrencyType = [
  { key: "ngn", text: "NGN" },
  { key: "usd", text: "USD" },
  { key: "gbp", text: "GBP" }
];

export const PaymentOption = [
  { key: "part", text: "Allow Part Payment" },
  { key: "full", text: "Only Full Payment" }
];

export const PaymentStatus = [
  { key: "saved", text: "Saved" },
  { key: "sent", text: "Sent" }
];

export const StructureType = [
  { key: "class", text: "Class" },
  { key: "student", text: "Student" },
  { key: "subject", text: "Subject" }
];

export const ContinousAssessment = [
  { key: "CA1", text: "CA1" },
  { key: "CA2", text: "CA2" }
];

export const Priority = [
  { key: "high", text: "High" },
  { key: "medium", text: "Medium" },
  { key: "low", text: "Low" }
];
export const Discount = [
  { key: "20off", text: "20% off" },
  { key: "medium", text: "30% off" },
  { key: "low", text: "100% off" }
];
export const PaymentMethod = [
  { key: "Cash", text: "Cash" },
  { key: "Bank Transfer", text: "Bank Transfer" },
  { key: "Card", text: "Card" },
  { key: "Payment Link", text: "Payment Link" }
];
export const ChatRole = [
  { key: "student", text: "Students" },
  { key: "hostel_master", text: "Hostel Master" },
  { key: "admin", text: "Admin" }
];
export const GuradianRole = [
  { key: "primary", text: "Primary" },
  { key: "secondary", text: "Secondary" }
];

export const ItemOption = [
  { key: "compulsory", text: "Compulsory" },
  { key: "optional", text: "Optional" }
];

export const ItemStatus = [
  { key: "active", text: "Active" },
  { key: "inactive", text: "Inactive" }
];

export const NoticeInfo = [
  { key: "info", text: "Info" },
  { key: "warning", text: "Warning" },
  { key: "policy change", text: "Policy Change" },
  { key: "lost & found", text: "Lost & Found" },
  { key: "reminder", text: "Reminder" },
  { key: "announcement", text: "Announcement" }
];

export const Grade = [
  { key: "dkenjdv1md", text: "A" },
  { key: "dkenidv3md", text: "B" },
  { key: "dke4njdumd", text: "C" },
  { key: "dkeejd5vmd", text: "D" },
  { key: "dk3enjdvsd", text: "E" },
  { key: "dkenjuvmd7", text: "F" }
];

export const ScoreLevel = [
  { key: "fdgshsdjxx", text: "70" },
  { key: "fdgshsdjex", text: "60" },
  { key: "fdgsesdjex", text: "50" },
  { key: "fdgsestjex", text: "40" },
  { key: "fdgs5vfmjd", text: "30" }
];

export const GoalCategory = [
  { key: "rkfngkjrgewrjg", text: "School Project" },
  { key: "kfnghjfnhfnjfs", text: "Class Project" },
  { key: "iijdjdduidvjvf", text: "Individual Project" }
];

export const Category = [
  { key: "knbvrburewvjb45kj", text: "Library Computer" },
  { key: "knbvrburewvjb45kj", text: "Laboratory Computer" },
  { key: "fdjnfjjedewvjb45kj", text: "Music Equipment" }
];

export const Quantity = [
  { key: "jbfve732yrinfkvnkj", text: "1" },
  { key: "jbfve732yrinffvhbd", text: "2" },
  { key: "jfnbjsfbjewbfghbvh", text: "3" },
  { key: "jbfve7323343232312", text: "4" },
  { key: "jbfve7jdvbjde3kjd3", text: "5" },
  { key: "jbfve732yrinf38373", text: "6" },
  { key: "jbfve73238783ihfdf", text: "7" },
  { key: "jbfve732y276289223", text: "8" },
  { key: "jbfve73238373y73rn", text: "9" },
  { key: "jbfve732262627293c", text: "10" }
];

export const Condition = [
  { key: "rklvnf3knmjkdjfd", text: "Used" },
  { key: "rklvnf3djdhgdjfd", text: "Un-Used" }
];

export const Department = [
  { key: "fjnurie4g3g4384", text: "Learning Materials" },
  { key: "fjnurie4g3eeee4", text: "School Store" },
  { key: "sdkfnsjkf328832", text: "Health Center" }
];
export const SupportDepartment = [
  { key: "marketing", text: "Marketing" },
  { key: "support", text: "Support" },
  { key: "sales", text: "Sales" }
];

export const ClassTeacher = [
  { key: "dkslvnkjfdvnjfvjkmfvjvj", text: "BolajiiOlayinkz" },
  { key: "dkslvnkjfdvnjfyubhghhvj", text: "Yinka" }
];

export const ClassType = [
  { key: "dkslvhhjhfvjkmfvjvj.", text: "Virtual" },
  { key: "dkslvnfdvnjfyubhghhvj.", text: "Physical" }
];

export const ClassLevel = [
  { key: "660ca63df5dd4337249be676", text: "JSS 1" },
  { key: "660ca63d8de5e359989bba89", text: "JSS 2" },
  { key: "660ca63d03c9822299c55c66", text: "JSS 3" },
  { key: "660ca63da0407ba57d782d2b", text: "SSS 1" },
  { key: "660ca63d205572c2337ea7d0", text: "SSS 2" },
  { key: "660ca63d8932ebaef4926bc4", text: "SSS 3" }
];

export const EnrollmentForm = [
  { key: "dfbvkngjrnfgjergj4lyxds", text: "Custom Form" },
  { key: "dfbvkngjrnfgjergjhy4lds", text: "Enrolment Form" }
];

export const Session = [
  { key: "jsdfbvjdsbvhjdsvjdhbvjb", text: "2023/2024" },
  { key: "jsdfbvjdsbvhjdsvjdhwvjb", text: "2024/2025" }
];

export const Weekdays = [
  { key: "660ca7df46e574381c27b5f8", text: "Monday" },
  { key: "660ca7df46fd8c62f6aaa6aa", text: "Tuesday" },
  { key: "660ca7df2a6fa5b2be8449e8", text: "Wednesday" },
  { key: "660ca7df2fa667a15af2c4ad", text: "Thursday" },
  { key: "660ca7df355298b087326a9f", text: "Friday" }
];

export const Weekday = ["mon", "tue", "wed", "thu", "fri"].map((day, index) => ({
  key: `day-${index + 1}`,
  text: day
}));

export const Numbers = [
  { key: "660ca7df46e574312381c27b5f8", text: "1" },
  { key: "660ca7df46fd8c62233f6aaa6aa", text: "2" },
  { key: "660ca7df2a6fa5b2be2348449e8", text: "3" },
  { key: "660ca7df2fa667a145555af2c4ad", text: "4" },
  { key: "660ca7df355298b0345387326a9f", text: "5" },
  { key: "660ca7df35529433345387326a9f", text: "6" }
];

export const Subject = [
  { key: "660ca4d52f42c7d47330614a", text: "Mathematics" },
  { key: "660ca4d5bfd06df138774cec", text: "Economics" },
  { key: "660ca4d530761ca389edb5bd", text: "English Language" },
  { key: "660ca4d5da040c5ef182b9c9", text: "Civic Eduction" },
  { key: "660ca4d53612171997563d13", text: "Biology" },
  { key: "660ca4d5bb53c86b3759ec8f", text: "Agricultural Science" },
  { key: "660ca4d500eae6add8aaf1e5", text: "Technical Drawing" },
  { key: "660ca4d5172b6da627201724", text: "Home Economics" }
];

export const ManagerScore = [
  { key: "jghuweghu383riib2", text: "1" },
  { key: "2234wwjsbhchshvhd", text: "2" },
  { key: "22kmekferhchshvhd", text: "3" },
  { key: "fvlkdsnjksdknjdkv", text: "4" },
  { key: "jfnjvnejvjej323324", text: "5" },
  { key: "dfgjndjgbref4485u8", text: "6" },
  { key: "dfbnjgbrjugurug4453", text: "7" },
  { key: "dfbnjgbrjgjgurug4453", text: "8" },
  { key: "dfbnjgdfgmugurug4453", text: "9" },
  { key: "dfbnjndhfdhgkgurug4453", text: "10" }
];

export const StaffScore = [
  { key: "vahfgfhururhyure993", text: "1" },
  { key: "jkbfvjhbvghreaj447y", text: "2" },
  { key: "88783hdfjhdfjbdjfbd", text: "3" },
  { key: "kmsjrkgjregre8u8ehr", text: "4" },
  { key: "kmsjrkgfgdffgngnehr", text: "5" },
  { key: "rkgnrgjrngjrgj43333", text: "6" },
  { key: "sfbnjervbnew3883382", text: "7" },
  { key: "mnvndjvsjdvjdv233298", text: "8" },
  { key: "vwjvbe8738y48338474r", text: "9" },
  { key: "kjsvbnbev3774234vnhd", text: "10" }
];

export const Term = [
  { key: "dgnsjkgnjkdsnjsdfbnjsfbnf", text: "First Term" },
  { key: "dgnsjkgnjkdsnjsdfbnndndnf", text: "Second Term" },
  { key: "dgnsjkgnjkddkjjdjdjndndnf", text: "Third Term" }
];

export const AgreedScore = [
  { key: "vjhbervrfgbg47ry534bv", text: "1" },
  { key: "ssdjgnjrebgu4tr4494j", text: "2" },
  { key: "kdnfgjrfjgnr48i8i449", text: "3" },
  { key: "vjhbervhfbvheery534bv", text: "4" },
  { key: "vjhberdfjgfb47ry534bv", text: "5" },
  { key: "vjhberv8474444ry534bv", text: "6" },
  { key: "vj3868973ncf47ry534bv", text: "7" },
  { key: "vj344vdfdfdf47ry534bv", text: "8" },
  { key: "vjhb449545gvv7ry534bv", text: "9" },
  { key: "vjhber384u4834ry534bv", text: "10" }
];

export const TestLabels = [
  { key: "educational", text: "Educational" },
  { key: "school_plan", text: "School Plan" }
];

export const NigerianStates = [
  { key: "abia", text: "Abia" },
  { key: "adamawa", text: "Adamawa" },
  { key: "akwa_ibom", text: "Akwa Ibom" },
  { key: "anambra", text: "Anambra" },
  { key: "bauchi", text: "Bauchi" },
  { key: "bayelsa", text: "Bayelsa" },
  { key: "benue", text: "Benue" },
  { key: "borno", text: "Borno" },
  { key: "cross_river", text: "Cross River" },
  { key: "delta", text: "Delta" },
  { key: "ebonyi", text: "Ebonyi" },
  { key: "edo", text: "Edo" },
  { key: "ekiti", text: "Ekiti" },
  { key: "enugu", text: "Enugu" },
  { key: "fct", text: "Federal Capital Territory" },
  { key: "gombe", text: "Gombe" },
  { key: "imo", text: "Imo" },
  { key: "jigawa", text: "Jigawa" },
  { key: "kaduna", text: "Kaduna" },
  { key: "kano", text: "Kano" },
  { key: "katsina", text: "Katsina" },
  { key: "kebbi", text: "Kebbi" },
  { key: "kogi", text: "Kogi" },
  { key: "kwara", text: "Kwara" },
  { key: "lagos", text: "Lagos" },
  { key: "nasarawa", text: "Nasarawa" },
  { key: "niger", text: "Niger" },
  { key: "ogun", text: "Ogun" },
  { key: "ondo", text: "Ondo" },
  { key: "osun", text: "Osun" },
  { key: "oyo", text: "Oyo" },
  { key: "plateau", text: "Plateau" },
  { key: "rivers", text: "Rivers" },
  { key: "sokoto", text: "Sokoto" },
  { key: "taraba", text: "Taraba" },
  { key: "yobe", text: "Yobe" },
  { key: "zamfara", text: "Zamfara" }
];

export const NigerianLGAs = {
  "Abia": [
    "Aba North",
    "Aba South",
    "Arochukwu",
    "Bende",
    "Ikwuano",
    "Isiala Ngwa North",
    "Isiala Ngwa South",
    "Isuikwuato",
    "Obi Ngwa",
    "Ohafia",
    "Osisioma",
    "Ugwunagbo",
    "Ukwa East",
    "Ukwa West",
    "Umuahia North",
    "Umuahia South",
    "Umu Nneochi"
  ],
  "Adamawa": [
    "Demsa",
    "Fufure",
    "Ganye",
    "Gayuk",
    "Gombi",
    "Grie",
    "Hong",
    "Jada",
    "Lamurde",
    "Madagali",
    "Maiha",
    "Mayo Belwa",
    "Michika",
    "Mubi North",
    "Mubi South",
    "Numan",
    "Shelleng",
    "Song",
    "Toungo",
    "Yola North",
    "Yola South"
  ],
  "Akwa Ibom": [
    "Abak",
    "Eastern Obolo",
    "Eket",
    "Esit Eket",
    "Essien Udim",
    "Etim Ekpo",
    "Etinan",
    "Ibeno",
    "Ibesikpo Asutan",
    "Ibiono-Ibom",
    "Ika",
    "Ikono",
    "Ikot Abasi",
    "Ikot Ekpene",
    "Ini",
    "Itu",
    "Mbo",
    "Mkpat-Enin",
    "Nsit-Atai",
    "Nsit-Ibom",
    "Nsit-Ubium",
    "Obot Akara",
    "Okobo",
    "Onna",
    "Oron",
    "Oruk Anam",
    "Udung-Uko",
    "Ukanafun",
    "Uruan",
    "Urue-Offong/Oruko",
    "Uyo"
  ],
  "Anambra": [
    "Aguata",
    "Anambra East",
    "Anambra West",
    "Anaocha",
    "Awka North",
    "Awka South",
    "Ayamelum",
    "Dunukofia",
    "Ekwusigo",
    "Idemili North",
    "Idemili South",
    "Ihiala",
    "Njikoka",
    "Nnewi North",
    "Nnewi South",
    "Ogbaru",
    "Onitsha North",
    "Onitsha South",
    "Orumba North",
    "Orumba South",
    "Oyi"
  ],
  "Bauchi": [
    "Alkaleri",
    "Bauchi",
    "Bogoro",
    "Damban",
    "Darazo",
    "Dass",
    "Gamawa",
    "Ganjuwa",
    "Giade",
    "Itas/Gadau",
    "Jama'are",
    "Katagum",
    "Kirfi",
    "Misau",
    "Ningi",
    "Shira",
    "Tafawa Balewa",
    "Toro",
    "Warji",
    "Zaki"
  ],
  "Bayelsa": [
    "Brass",
    "Ekeremor",
    "Kolokuma/Opokuma",
    "Nembe",
    "Ogbia",
    "Sagbama",
    "Southern Ijaw",
    "Yenagoa"
  ],
  "Benue": [
    "Ado",
    "Agatu",
    "Apa",
    "Buruku",
    "Gboko",
    "Guma",
    "Gwer East",
    "Gwer West",
    "Katsina-Ala",
    "Konshisha",
    "Kwande",
    "Logo",
    "Makurdi",
    "Obi",
    "Ogbadibo",
    "Ohimini",
    "Oju",
    "Okpokwu",
    "Oturkpo",
    "Tarka",
    "Ukum",
    "Ushongo",
    "Vandeikya"
  ],
  "Borno": [
    "Abadam",
    "Askira/Uba",
    "Bama",
    "Bayo",
    "Biu",
    "Chibok",
    "Damboa",
    "Dikwa",
    "Gubio",
    "Guzamala",
    "Gwoza",
    "Hawul",
    "Jere",
    "Kaga",
    "Kala/Balge",
    "Konduga",
    "Kukawa",
    "Kwaya Kusar",
    "Mafa",
    "Magumeri",
    "Maiduguri",
    "Marte",
    "Mobbar",
    "Monguno",
    "Ngala",
    "Nganzai",
    "Shani"
  ],
  "Cross River": [
    "Abi",
    "Akamkpa",
    "Akpabuyo",
    "Bakassi",
    "Bekwarra",
    "Biase",
    "Boki",
    "Calabar Municipal",
    "Calabar South",
    "Etung",
    "Ikom",
    "Obanliku",
    "Obubra",
    "Obudu",
    "Odukpani",
    "Ogoja",
    "Yakuur",
    "Yala"
  ],
  "Delta": [
    "Aniocha North",
    "Aniocha South",
    "Bomadi",
    "Burutu",
    "Ethiope East",
    "Ethiope West",
    "Ika North East",
    "Ika South",
    "Isoko North",
    "Isoko South",
    "Ndokwa East",
    "Ndokwa West",
    "Okpe",
    "Oshimili North",
    "Oshimili South",
    "Patani",
    "Sapele",
    "Udu",
    "Ughelli North",
    "Ughelli South",
    "Ukwuani",
    "Uvwie",
    "Warri North",
    "Warri South",
    "Warri South West"
  ],
  "Ebonyi": [
    "Abakaliki",
    "Afikpo North",
    "Afikpo South",
    "Ebonyi",
    "Ezza North",
    "Ezza South",
    "Ikwo",
    "Ishielu",
    "Ivo",
    "Izzi",
    "Ohaozara",
    "Ohaukwu",
    "Onicha"
  ],
  "Edo": [
    "Akoko-Edo",
    "Egor",
    "Esan Central",
    "Esan North-East",
    "Esan South-East",
    "Esan West",
    "Etsako Central",
    "Etsako East",
    "Etsako West",
    "Igueben",
    "Ikpoba Okha",
    "Orhionmwon",
    "Oredo",
    "Ovia North-East",
    "Ovia South-West",
    "Owan East",
    "Owan West",
    "Uhunmwonde"
  ],
  "Ekiti": [
    "Ado Ekiti",
    "Efon",
    "Ekiti East",
    "Ekiti South-West",
    "Ekiti West",
    "Emure",
    "Gbonyin",
    "Ido Osi",
    "Ijero",
    "Ikere",
    "Ikole",
    "Ilejemeje",
    "Irepodun/Ifelodun",
    "Ise/Orun",
    "Moba",
    "Oye"
  ],
  "Enugu": [
    "Aninri",
    "Awgu",
    "Enugu East",
    "Enugu North",
    "Enugu South",
    "Ezeagu",
    "Igbo Etiti",
    "Igbo Eze North",
    "Igbo Eze South",
    "Isi Uzo",
    "Nkanu East",
    "Nkanu West",
    "Nsukka",
    "Oji River",
    "Udenu",
    "Udi",
    "Uzo Uwani"
  ],
  "FCT": [
    "Abaji",
    "Bwari",
    "Gwagwalada",
    "Kuje",
    "Kwali",
    "Municipal Area Council"
  ],
  "Gombe": [
    "Akko",
    "Balanga",
    "Billiri",
    "Dukku",
    "Funakaye",
    "Gombe",
    "Kaltungo",
    "Kwami",
    "Nafada",
    "Shongom",
    "Yamaltu/Deba"
  ],
  "Imo": [
    "Aboh Mbaise",
    "Ahiazu Mbaise",
    "Ehime Mbano",
    "Ezinihitte",
    "Ideato North",
    "Ideato South",
    "Ihitte/Uboma",
    "Ikeduru",
    "Isiala Mbano",
    "Isu",
    "Mbaitoli",
    "Ngor Okpala",
    "Njaba",
    "Nkwerre",
    "Nwangele",
    "Obowo",
    "Oguta",
    "Ohaji/Egbema",
    "Okigwe",
    "Orlu",
    "Orsu",
    "Oru East",
    "Oru West",
    "Owerri Municipal",
    "Owerri North",
    "Owerri West",
    "Unuimo"
  ],
  "Jigawa": [
    "Auyo",
    "Babura",
    "Biriniwa",
    "Birnin Kudu",
    "Buji",
    "Dutse",
    "Gagarawa",
    "Garki",
    "Gumel",
    "Guri",
    "Gwaram",
    "Gwiwa",
    "Hadejia",
    "Jahun",
    "Kafin Hausa",
    "Kazaure",
    "Kiri Kasama",
    "Kiyawa",
    "Kaugama",
    "Maigatari",
    "Malam Madori",
    "Miga",
    "Ringim",
    "Roni",
    "Sule Tankarkar",
    "Taura",
    "Yankwashi"
  ],
  "Kaduna": [
    "Birnin Gwari",
    "Chikun",
    "Giwa",
    "Igabi",
    "Ikara",
    "Jaba",
    "Jema'a",
    "Kachia",
    "Kaduna North",
    "Kaduna South",
    "Kagarko",
    "Kajuru",
    "Kaura",
    "Kauru",
    "Kubau",
    "Kudan",
    "Lere",
    "Makarfi",
    "Sabon Gari",
    "Sanga",
    "Soba",
    "Zangon Kataf",
    "Zaria"
  ],
  "Kano": [
    "Ajingi",
    "Albasu",
    "Bagwai",
    "Bebeji",
    "Bichi",
    "Bunkure",
    "Dala",
    "Dambatta",
    "Dawakin Kudu",
    "Dawakin Tofa",
    "Doguwa",
    "Fagge",
    "Gabasawa",
    "Garko",
    "Garun Mallam",
    "Gaya",
    "Gezawa",
    "Gwale",
    "Gwarzo",
    "Kabo",
    "Kano Municipal",
    "Karaye",
    "Kibiya",
    "Kiru",
    "Kumbotso",
    "Kunchi",
    "Kura",
    "Madobi",
    "Makoda",
    "Minjibir",
    "Nasarawa",
    "Rano",
    "Rimin Gado",
    "Rogo",
    "Shanono",
    "Sumaila",
    "Takai",
    "Tarauni",
    "Tofa",
    "Tsanyawa",
    "Tudun Wada",
    "Ungogo",
    "Warawa",
    "Wudil"
  ],
  "Katsina": [
    "Bakori",
    "Batagarawa",
    "Batsari",
    "Baure",
    "Bindawa",
    "Charanchi",
    "Dandume",
    "Danja",
    "Dan Musa",
    "Daura",
    "Dutsi",
    "Dutsin Ma",
    "Faskari",
    "Funtua",
    "Ingawa",
    "Jibia",
    "Kafur",
    "Kaita",
    "Kankara",
    "Kankia",
    "Katsina",
    "Kurfi",
    "Kusada",
    "Mai'Adua",
    "Malumfashi",
    "Mani",
    "Mashi",
    "Matazu",
    "Musawa",
    "Rimi",
    "Sabuwa",
    "Safana",
    "Sandamu",
    "Zango"
  ],
  "Kebbi": [
    "Aleiro",
    "Arewa Dandi",
    "Argungu",
    "Augie",
    "Bagudo",
    "Birnin Kebbi",
    "Bunza",
    "Dandi",
    "Fakai",
    "Gwandu",
    "Jega",
    "Kalgo",
    "Koko/Besse",
    "Maiyama",
    "Ngaski",
    "Sakaba",
    "Shanga",
    "Suru",
    "Wasagu/Danko",
    "Yauri",
    "Zuru"
  ],
  "Kogi": [
    "Adavi",
    "Ajaokuta",
    "Ankpa",
    "Bassa",
    "Dekina",
    "Ibaji",
    "Idah",
    "Igalamela Odolu",
    "Ijumu",
    "Kabba/Bunu",
    "Kogi",
    "Lokoja",
    "Mopa Muro",
    "Ofu",
    "Ogori/Magongo",
    "Okehi",
    "Okene",
    "Olamaboro",
    "Omala",
    "Yagba East",
    "Yagba West"
  ],
  "Kwara": [
    "Asa",
    "Baruten",
    "Edu",
    "Ekiti",
    "Ifelodun",
    "Ilorin East",
    "Ilorin South",
    "Ilorin West",
    "Irepodun",
    "Isin",
    "Kaiama",
    "Moro",
    "Offa",
    "Oke Ero",
    "Oyun",
    "Pategi"
  ],
  "Lagos": [
    "Agege",
    "Ajeromi-Ifelodun",
    "Alimosho",
    "Amuwo-Odofin",
    "Apapa",
    "Badagry",
    "Epe",
    "Eti Osa",
    "Ibeju-Lekki",
    "Ifako-Ijaiye",
    "Ikeja",
    "Ikorodu",
    "Kosofe",
    "Lagos Island",
    "Lagos Mainland",
    "Mushin",
    "Ojo",
    "Oshodi-Isolo",
    "Shomolu",
    "Surulere"
  ],
  "Nasarawa": [
    "Akwanga",
    "Awe",
    "Doma",
    "Karu",
    "Keana",
    "Keffi",
    "Kokona",
    "Lafia",
    "Nasarawa",
    "Nasarawa Egon",
    "Obi",
    "Toto",
    "Wamba"
  ],
  "Niger": [
    "Agaie",
    "Agwara",
    "Bida",
    "Borgu",
    "Bosso",
    "Chanchaga",
    "Edati",
    "Gbako",
    "Gurara",
    "Katcha",
    "Kontagora",
    "Lapai",
    "Lavun",
    "Magama",
    "Mariga",
    "Mashegu",
    "Mokwa",
    "Moya",
    "Paikoro",
    "Rafi",
    "Rijau",
    "Shiroro",
    "Suleja",
    "Tafa",
    "Wushishi"
  ],
  "Ogun": [
    "Abeokuta North",
    "Abeokuta South",
    "Ado-Odo/Ota",
    "Egbado North",
    "Egbado South",
    "Ewekoro",
    "Ifo",
    "Ijebu East",
    "Ijebu North",
    "Ijebu North East",
    "Ijebu Ode",
    "Ikenne",
    "Imeko Afon",
    "Ipokia",
    "Obafemi Owode",
    "Odeda",
    "Odogbolu",
    "Ogun Waterside",
    "Remo North",
    "Shagamu"
  ],
  "Ondo": [
    "Akoko North-East",
    "Akoko North-West",
    "Akoko South-East",
    "Akoko South-West",
    "Akure North",
    "Akure South",
    "Ese Odo",
    "Idanre",
    "Ifedore",
    "Ilaje",
    "Ile Oluji/Okeigbo",
    "Irele",
    "Odigbo",
    "Okitipupa",
    "Ondo East",
    "Ondo West",
    "Ose",
    "Owo"
  ],
  "Osun": [
    "Atakunmosa East",
    "Atakunmosa West",
    "Aiyedaade",
    "Aiyedire",
    "Boluwaduro",
    "Boripe",
    "Ede North",
    "Ede South",
    "Egbedore",
    "Ejigbo",
    "Ife Central",
    "Ife East",
    "Ife North",
    "Ife South",
    "Ifedayo",
    "Ila",
    "Ilesa East",
    "Ilesa West",
    "Irepodun",
    "Irewole",
    "Isokan",
    "Iwo",
    "Obokun",
    "Odo Otin",
    "Ola Oluwa",
    "Olorunda",
    "Oriade",
    "Orolu",
    "Osogbo"
  ],
  "Oyo": [
    "Afijio",
    "Akinyele",
    "Atiba",
    "Atisbo",
    "Egbeda",
    "Ibadan North",
    "Ibadan North-East",
    "Ibadan North-West",
    "Ibadan South-East",
    "Ibadan South-West",
    "Ibarapa Central",
    "Ibarapa East",
    "Ibarapa North",
    "Ido",
    "Irepo",
    "Iseyin",
    "Itesiwaju",
    "Iwajowa",
    "Kajola",
    "Lagelu",
    "Ogbomosho North",
    "Ogbomosho South",
    "Ogo Oluwa",
    "Olorunsogo",
    "Oluyole",
    "Ona Ara",
    "Orelope",
    "Ori Ire",
    "Oyo East",
    "Oyo West",
    "Saki East",
    "Saki West",
    "Surulere"
  ],
  "Plateau": [
    "Barkin Ladi",
    "Bassa",
    "Bokkos",
    "Jos East",
    "Jos North",
    "Jos South",
    "Kanam",
    "Kanke",
    "Langtang South",
    "Langtang North",
    "Mangu",
    "Mikang",
    "Pankshin",
    "Qua'an Pan",
    "Riyom",
    "Shendam",
    "Wase"
  ],
  "Rivers": [
    "Abua/Odual",
    "Ahoada East",
    "Ahoada West",
    "Akuku-Toru",
    "Andoni",
    "Asari-Toru",
    "Bonny",
    "Degema",
    "Eleme",
    "Emuoha",
    "Etche",
    "Gokana",
    "Ikwerre",
    "Khana",
    "Obio/Akpor",
    "Ogba/Egbema/Ndoni",
    "Ogu/Bolo",
    "Okrika",
    "Omuma",
    "Opobo/Nkoro",
    "Oyigbo",
    "Port Harcourt",
    "Tai"
  ],
  "Sokoto": [
    "Binji",
    "Bodinga",
    "Dange Shuni",
    "Gada",
    "Goronyo",
    "Gudu",
    "Gwadabawa",
    "Illela",
    "Isa",
    "Kebbe",
    "Kware",
    "Rabah",
    "Sabon Birni",
    "Shagari",
    "Silame",
    "Sokoto North",
    "Sokoto South",
    "Tambuwal",
    "Tangaza",
    "Tureta",
    "Wamako",
    "Wurno",
    "Yabo"
  ],
  "Taraba": [
    "Ardo Kola",
    "Bali",
    "Donga",
    "Gashaka",
    "Gassol",
    "Ibi",
    "Jalingo",
    "Karim Lamido",
    "Kurmi",
    "Lau",
    "Sardauna",
    "Takum",
    "Ussa",
    "Wukari",
    "Yorro",
    "Zing"
  ],
  "Yobe": [
    "Bade",
    "Bursari",
    "Damaturu",
    "Fika",
    "Fune",
    "Geidam",
    "Gujba",
    "Gulani",
    "Jakusko",
    "Karasuwa",
    "Machina",
    "Nangere",
    "Nguru",
    "Potiskum",
    "Tarmuwa",
    "Yunusari",
    "Yusufari"
  ],
  "Zamfara": [
    "Anka",
    "Bakura",
    "Birnin Magaji/Kiyaw",
    "Bukkuyum",
    "Bungudu",
    "Gummi",
    "Gusau",
    "Kaura Namoda",
    "Maradun",
    "Maru",
    "Shinkafi",
    "Talata Mafara",
    "Chafe",
    "Zurmi"
  ]
};

export const MaritalStatus = [
  {
    key: "single",
    text: "Single"
  },
  {
    key: "married",
    text: "Married"
  },
  {
    key: "living-together",
    text: "Living Together"
  },
  {
    key: "divorced-separated",
    text: "Divorced/Separated"
  },
  {
    key: "widowed",
    text: "Widowed"
  }
];

export const Countries = [

  {
    "name": "Afghanistan",
    "Iso2": "af",
    "callingCode": "+93"
  },
  {
    "name": "Albania",
    "Iso2": "al",
    "callingCode": "+355"
  },
  {
    "name": "Algeria",
    "Iso2": "dz",
    "callingCode": "+213"
  },
  {
    "name": "Andorra",
    "Iso2": "ad",
    "callingCode": "+376"
  },
  {
    "name": "Angola",
    "Iso2": "ao",
    "callingCode": "+244"
  },
  {
    "name": "Antigua and Barbuda",
    "Iso2": "ag",
    "callingCode": "+1268"
  },
  {
    "name": "Argentina",
    "Iso2": "ar",
    "callingCode": "+54"
  },
  {
    "name": "Armenia",
    "Iso2": "am",
    "callingCode": "+374"
  },
  {
    "name": "Aruba",
    "Iso2": "aw",
    "callingCode": "+297"
  },
  {
    "name": "Australia",
    "Iso2": "au",
    "callingCode": "+61"
  },
  {
    "name": "Austria",
    "Iso2": "at",
    "callingCode": "+43"
  },
  {
    "name": "Azerbaijan",
    "Iso2": "az",
    "callingCode": "+994"
  },
  {
    "name": "Bahamas",
    "Iso2": "bs",
    "callingCode": "+1242"
  },
  {
    "name": "Bahrain",
    "Iso2": "bh",
    "callingCode": "+973"
  },
  {
    "name": "Bangladesh",
    "Iso2": "bd",
    "callingCode": "+880"
  },
  {
    "name": "Barbados",
    "Iso2": "bb",
    "callingCode": "+1246"
  },
  {
    "name": "Belarus",
    "Iso2": "by",
    "callingCode": "+375"
  },
  {
    "name": "Belgium",
    "Iso2": "be",
    "callingCode": "+32"
  },
  {
    "name": "Belize",
    "Iso2": "bz",
    "callingCode": "+501"
  },
  {
    "name": "Benin",
    "Iso2": "bj",
    "callingCode": "+229"
  },
  {
    "name": "Bhutan",
    "Iso2": "bt",
    "callingCode": "+975"
  },
  {
    "name": "Bolivia",
    "Iso2": "bo",
    "callingCode": "+591"
  },
  {
    "name": "Bosnia and Herzegovina",
    "Iso2": "ba",
    "callingCode": "+387"
  },
  {
    "name": "Botswana",
    "Iso2": "bw",
    "callingCode": "+267"
  },
  {
    "name": "Brazil",
    "Iso2": "br",
    "callingCode": "+55"
  },
  {
    "name": "Brunei",
    "Iso2": "bn",
    "callingCode": "+673"
  },
  {
    "name": "Bulgaria",
    "Iso2": "bg",
    "callingCode": "+359"
  },
  {
    "name": "Burkina Faso",
    "Iso2": "bf",
    "callingCode": "+226"
  },
  {
    "name": "Burundi",
    "Iso2": "bi",
    "callingCode": "+257"
  },
  {
    "name": "Cambodia",
    "Iso2": "kh",
    "callingCode": "+855"
  },
  {
    "name": "Cameroon",
    "Iso2": "cm",
    "callingCode": "+237"
  },
  {
    "name": "Canada",
    "Iso2": "ca",
    "callingCode": "+1"
  },
  {
    "name": "Cape Verde",
    "Iso2": "cv",
    "callingCode": "+238"
  },
  {
    "name": "Caribbean Netherlands",
    "Iso2": "bq",
    "callingCode": "+599"
  },
  {
    "name": "Central African Republic",
    "Iso2": "cf",
    "callingCode": "+236"
  },
  {
    "name": "Chad (Tchad)",
    "Iso2": "td",
    "callingCode": "+235"
  },
  {
    "name": "Chile",
    "Iso2": "cl",
    "callingCode": "+56"
  },
  {
    "name": "China",
    "Iso2": "cn",
    "callingCode": "+86"
  },
  {
    "name": "Colombia",
    "Iso2": "co",
    "callingCode": "+57"
  },
  {
    "name": "Comoros",
    "Iso2": "km",
    "callingCode": "+269"
  },
  {
    "name": "Congo",
    "Iso2": "cd",
    "callingCode": "+243"
  },
  {
    "mame": "Congo",
    "Iso2": "cg",
    "callingCode": "+242"
  },
  {
    "name": "Costa Rica",
    "Iso2": "cr",
    "callingCode": "+506"
  },
  {
    "name": "Côte d’Ivoire",
    "Iso2": "ci",
    "callingCode": "+225"
  },
  {
    "name": "Croatia",
    "Iso2": "hr",
    "callingCode": "+385"
  },
  {
    "name": "Cuba",
    "Iso2": "cu",
    "callingCode": "+53"
  },
  {
    "name": "Curaçao",
    "Iso2": "cw",
    "callingCode": "+599"
  },
  {
    "name": "Cyprus",
    "Iso2": "cy",
    "callingCode": "+357"
  },
  {
    "name": "Czech Republic",
    "Iso2": "cz",
    "callingCode": "+420"
  },
  {
    "name": "Denmark",
    "Iso2": "dk",
    "callingCode": "+45"
  },
  {
    "name": "Djibouti",
    "Iso2": "dj",
    "callingCode": "+253"
  },
  {
    "name": "Dominica",
    "Iso2": "dm",
    "callingCode": "+1767"
  },
  {
    "name": "Dominican Republic",
    "Iso2": "do",
    "callingCode": "+1"
  },
  {
    "name": "Ecuador",
    "Iso2": "ec",
    "callingCode": "+593"
  },
  {
    "name": "Egypt",
    "Iso2": "eg",
    "callingCode": "+20"
  },
  {
    "name": "El Salvador",
    "Iso2": "sv",
    "callingCode": "+503"
  },
  {
    "name": "Equatorial Guinea",
    "Iso2": "gq",
    "callingCode": "+240"
  },
  {
    "name": "Eritrea",
    "Iso2": "er",
    "callingCode": "+291"
  },
  {
    "name": "Estonia",
    "Iso2": "ee",
    "callingCode": "+372"
  },
  {
    "name": "Ethiopia",
    "Iso2": "et",
    "callingCode": "+251"
  },
  {
    "name": "Faroe Islands",
    "Iso2": "fo",
    "callingCode": "+298"
  },
  {
    "name": "Fiji",
    "Iso2": "fj",
    "callingCode": "+679"
  },
  {
    "name": "Finland",
    "Iso2": "fi",
    "callingCode": "+358"
  },
  {
    "name": "France",
    "Iso2": "fr",
    "callingCode": "+33"
  },
  {
    "name": "French Guiana",
    "Iso2": "gf",
    "callingCode": "+594"
  },
  {
    "name": "French Polynesia",
    "Iso2": "pf",
    "callingCode": "+689"
  },
  {
    "name": "Gabon",
    "Iso2": "ga",
    "callingCode": "+241"
  },
  {
    "name": "Gambia",
    "Iso2": "gm",
    "callingCode": "+220"
  },
  {
    "name": "Georgia",
    "Iso2": "ge",
    "callingCode": "+995"
  },
  {
    "name": "Germany",
    "Iso2": "de",
    "callingCode": "+49"
  },
  {
    "name": "Ghana",
    "Iso2": "gh",
    "callingCode": "+233"
  },
  {
    "name": "Gibraltar",
    "Iso2": "gi",
    "callingCode": "+350"
  },
  {
    "name": "Greece",
    "Iso2": "gr",
    "callingCode": "+30"
  },
  {
    "name": "Greenland",
    "Iso2": "gl",
    "callingCode": "+299"
  },
  {
    "name": "Grenada",
    "Iso2": "gd",
    "callingCode": "+1473"
  },
  {
    "name": "Guadeloupe",
    "Iso2": "gp",
    "callingCode": "+590"
  },
  {
    "name": "Guam",
    "Iso2": "gu",
    "callingCode": "+1671"
  },
  {
    "name": "Guatemala",
    "Iso2": "gt",
    "callingCode": "+502"
  },
  {
    "name": "Guernsey",
    "Iso2": "gg",
    "callingCode": "+44"
  },
  {
    "name": "Guinea",
    "Iso2": "gn",
    "callingCode": "+224"
  },
  {
    "name": "Guinea-Bissau",
    "Iso2": "gw",
    "callingCode": "+245"
  },
  {
    "name": "Guyana",
    "Iso2": "gy",
    "callingCode": "+592"
  },
  {
    "name": "Haiti",
    "Iso2": "ht",
    "callingCode": "+509"
  },
  {
    "name": "Honduras",
    "Iso2": "hn",
    "callingCode": "+504"
  },
  {
    "name": "Hong Kong",
    "Iso2": "hk",
    "callingCode": "+852"
  },
  {
    "name": "Hungary",
    "Iso2": "hu",
    "callingCode": "+36"
  },
  {
    "name": "Iceland",
    "Iso2": "is",
    "callingCode": "+354"
  },
  {
    "name": "India",
    "Iso2": "in",
    "callingCode": "+91"
  },
  {
    "name": "Indonesia",
    "Iso2": "id",
    "callingCode": "+62"
  },
  {
    "name": "Iran",
    "Iso2": "ir",
    "callingCode": "+98"
  },
  {
    "name": "Iraq",
    "Iso2": "iq",
    "callingCode": "+964"
  },
  {
    "name": "Ireland",
    "Iso2": "ie",
    "callingCode": "+353"
  },
  {
    "name": "Israel",
    "Iso2": "il",
    "callingCode": "+972"
  },
  {
    "name": "Italy",
    "Iso2": "it",
    "callingCode": "+39"
  },
  {
    "name": "Jamaica",
    "Iso2": "jm",
    "callingCode": "+1876"
  },
  {
    "name": "Japan",
    "Iso2": "jp",
    "callingCode": "+81"
  },
  {
    "name": "Jersey",
    "Iso2": "je",
    "callingCode": "+44"
  },
  {
    "name": "Jordan",
    "Iso2": "jo",
    "callingCode": "+962"
  },
  {
    "name": "Kazakhstan",
    "Iso2": "kz",
    "callingCode": "+7"
  },
  {
    "name": "Kenya",
    "Iso2": "ke",
    "callingCode": "+254"
  },
  {
    "name": "Kiribati",
    "Iso2": "ki",
    "callingCode": "+686"
  },
  {
    "name": "Kosovo",
    "Iso2": "xk",
    "callingCode": "+383"
  },
  {
    "name": "Kuwait",
    "Iso2": "kw",
    "callingCode": "+965"
  },
  {
    "name": "Kyrgyzstan",
    "Iso2": "kg",
    "callingCode": "+996"
  },
  {
    "name": "Laos",
    "Iso2": "la",
    "callingCode": "+856"
  },
  {
    "name": "Latvia",
    "Iso2": "lv",
    "callingCode": "+371"
  },
  {
    "name": "Lebanon",
    "Iso2": "lb",
    "callingCode": "+961"
  },
  {
    "name": "Lesotho",
    "Iso2": "ls",
    "callingCode": "+266"
  },
  {
    "name": "Liberia",
    "Iso2": "lr",
    "callingCode": "+231"
  },
  {
    "name": "Libya",
    "Iso2": "ly",
    "callingCode": "+218"
  },
  {
    "name": "Liechtenstein",
    "Iso2": "li",
    "callingCode": "+423"
  },
  {
    "name": "Lithuania",
    "Iso2": "lt",
    "callingCode": "+370"
  },
  {
    "name": "Luxembourg",
    "Iso2": "lu",
    "callingCode": "+352"
  },
  {
    "name": "Macau",
    "Iso2": "mo",
    "callingCode": "+853"
  },
  {
    "name": "Macedonia",
    "Iso2": "mk",
    "callingCode": "+389"
  },
  {
    "name": "Madagascar",
    "Iso2": "mg",
    "callingCode": "+261"
  },
  {
    "name": "Malawi",
    "Iso2": "mw",
    "callingCode": "+265"
  },
  {
    "name": "Malaysia",
    "Iso2": "my",
    "callingCode": "+60"
  },
  {
    "name": "Maldives",
    "Iso2": "mv",
    "callingCode": "+960"
  },
  {
    "name": "Mali",
    "Iso2": "ml",
    "callingCode": "+223"
  },
  {
    "name": "Malta",
    "Iso2": "mt",
    "callingCode": "+356"
  },
  {
    "name": "Marshall Islands",
    "Iso2": "mh",
    "callingCode": "+692"
  },
  {
    "name": "Martinique",
    "Iso2": "mq",
    "callingCode": "+596"
  },
  {
    "name": "Mauritania",
    "Iso2": "mr",
    "callingCode": "+222"
  },
  {
    "name": "Mauritius",
    "Iso2": "mu",
    "callingCode": "+230"
  },
  {
    "name": "Mayotte",
    "Iso2": "yt",
    "callingCode": "+262"
  },
  {
    "name": "Mexico",
    "Iso2": "mx",
    "callingCode": "+52"
  },
  {
    "name": "Micronesia",
    "Iso2": "fm",
    "callingCode": "+691"
  },
  {
    "name": "Moldova",
    "Iso2": "md",
    "callingCode": "+373"
  },
  {
    "name": "Monaco",
    "Iso2": "mc",
    "callingCode": "+377"
  },
  {
    "name": "Mongolia",
    "Iso2": "mn",
    "callingCode": "+976"
  },
  {
    "name": "Montenegro",
    "Iso2": "me",
    "callingCode": "+382"
  },
  {
    "name": "Morocco",
    "Iso2": "ma",
    "callingCode": "+212"
  },
  {
    "name": "Mozambique",
    "Iso2": "mz",
    "callingCode": "+258"
  },
  {
    "name": "Myanmar",
    "Iso2": "mm",
    "callingCode": "+95"
  },
  {
    "name": "Namibia",
    "Iso2": "na",
    "callingCode": "+264"
  },
  {
    "name": "Nauru",
    "Iso2": "nr",
    "callingCode": "+674"
  },
  {
    "name": "Nepal",
    "Iso2": "np",
    "callingCode": "+977"
  },
  {
    "name": "Netherlands",
    "Iso2": "nl",
    "callingCode": "+31"
  },
  {
    "name": "New Caledonia",
    "Iso2": "nc",
    "callingCode": "+687"
  },
  {
    "name": "New Zealand",
    "Iso2": "nz",
    "callingCode": "+64"
  },
  {
    "name": "Nicaragua",
    "Iso2": "ni",
    "callingCode": "+505"
  },
  {
    "name": "Niger",
    "Iso2": "ne",
    "callingCode": "+227"
  },
  {
    "name": "Nigeria",
    "Iso2": "ng",
    "callingCode": "+234"
  },
  {
    "name": "Niue",
    "Iso2": "nu",
    "callingCode": "+683"
  },
  {
    "name": "Norfolk Island",
    "Iso2": "nf",
    "callingCode": "+672"
  },
  {
    "name": "North Korea",
    "Iso2": "kp",
    "callingCode": "+850"
  },
  {
    "name": "Norway",
    "Iso2": "no",
    "callingCode": "+47"
  },
  {
    "name": "Oman",
    "Iso2": "om",
    "callingCode": "+968"
  },
  {
    "name": "Pakistan",
    "Iso2": "pk",
    "callingCode": "+92"
  },
  {
    "name": "Palau",
    "Iso2": "pw",
    "callingCode": "+680"
  },
  {
    "name": "Palestine",
    "Iso2": "ps",
    "callingCode": "+970"
  },
  {
    "name": "Panama",
    "Iso2": "pa",
    "callingCode": "+507"
  },
  {
    "name": "Papua New Guinea",
    "Iso2": "pg",
    "callingCode": "+675"
  },
  {
    "name": "Paraguay",
    "Iso2": "py",
    "callingCode": "+595"
  },
  {
    "name": "Peru",
    "Iso2": "pe",
    "callingCode": "+51"
  },
  {
    "name": "Philippines",
    "Iso2": "ph",
    "callingCode": "+63"
  },
  {
    "name": "Poland",
    "Iso2": "pl",
    "callingCode": "+48"
  },
  {
    "name": "Portugal",
    "Iso2": "pt",
    "callingCode": "+351"
  },
  {
    "name": "Puerto Rico",
    "Iso2": "pr",
    "callingCode": "+1"
  },
  {
    "name": "Qatar",
    "Iso2": "qa",
    "callingCode": "+974"
  },
  {
    "name": "Réunion",
    "Iso2": "re",
    "callingCode": "+262"
  },
  {
    "name": "Romania",
    "Iso2": "ro",
    "callingCode": "+40"
  },
  {
    "name": "Russia",
    "Iso2": "ru",
    "callingCode": "+7"
  },
  {
    "name": "Rwanda",
    "Iso2": "rw",
    "callingCode": "+250"
  },
  {
    "name": "Saint Barthélemy",
    "Iso2": "bl",
    "callingCode": "+590"
  },
  {
    "name": "Saint Helena",
    "Iso2": "sh",
    "callingCode": "+290"
  },
  {
    "name": "Saint Kitts and Nevis",
    "Iso2": "kn",
    "callingCode": "+1869"
  },
  {
    "name": "Saint Lucia",
    "Iso2": "lc",
    "callingCode": "+1758"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "Iso2": "vc",
    "callingCode": "+1784"
  },
  {
    "name": "Samoa",
    "Iso2": "ws",
    "callingCode": "+685"
  },
  {
    "name": "San Marino",
    "Iso2": "sm",
    "callingCode": "+378"
  },
  {
    "name": "São Tomé and Príncipe",
    "Iso2": "st",
    "callingCode": "+239"
  },
  {
    "name": "Saudi Arabia",
    "Iso2": "sa",
    "callingCode": "+966"
  },
  {
    "name": "Senegal",
    "Iso2": "sn",
    "callingCode": "+221"
  },
  {
    "name": "Serbia",
    "Iso2": "rs",
    "callingCode": "+381"
  },
  {
    "name": "Seychelles",
    "Iso2": "sc",
    "callingCode": "+248"
  },
  {
    "name": "Sierra Leone",
    "Iso2": "sl",
    "callingCode": "+232"
  },
  {
    "name": "Singapore",
    "Iso2": "sg",
    "callingCode": "+65"
  },
  {
    "name": "Slovakia",
    "Iso2": "sk",
    "callingCode": "+421"
  },
  {
    "name": "Slovenia",
    "Iso2": "si",
    "callingCode": "+386"
  },
  {
    "name": "Solomon Islands",
    "Iso2": "sb",
    "callingCode": "+677"
  },
  {
    "name": "Somalia",
    "Iso2": "so",
    "callingCode": "+252"
  },
  {
    "name": "South Africa",
    "Iso2": "za",
    "callingCode": "+27"
  },
  {
    "name": "South Korea",
    "Iso2": "kr",
    "callingCode": "+82"
  },
  {
    "name": "South Sudan",
    "Iso2": "ss",
    "callingCode": "+211"
  },
  {
    "name": "Spain",
    "Iso2": "es",
    "callingCode": "+34"
  },
  {
    "name": "Sri Lanka",
    "Iso2": "lk",
    "callingCode": "+94"
  },
  {
    "name": "Sudan",
    "Iso2": "sd",
    "callingCode": "+249"
  },
  {
    "name": "Suriname",
    "Iso2": "sr",
    "callingCode": "+597"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "Iso2": "sj",
    "callingCode": "+47"
  },
  {
    "name": "Swaziland",
    "Iso2": "sz",
    "callingCode": "+268"
  },
  {
    "name": "Sweden",
    "Iso2": "se",
    "callingCode": "+46"
  },
  {
    "name": "Switzerland",
    "Iso2": "ch",
    "callingCode": "+41"
  },
  {
    "name": "Syria",
    "Iso2": "sy",
    "callingCode": "+963"
  },
  {
    "name": "Taiwan",
    "Iso2": "tw",
    "callingCode": "+886"
  },
  {
    "name": "Tajikistan",
    "Iso2": "tj",
    "callingCode": "+992"
  },
  {
    "name": "Tanzania",
    "Iso2": "tz",
    "callingCode": "+255"
  },
  {
    "name": "Thailand",
    "Iso2": "th",
    "callingCode": "+66"
  },
  {
    "name": "Timor-Leste",
    "Iso2": "tl",
    "callingCode": "+670"
  },
  {
    "name": "Togo",
    "Iso2": "tg",
    "callingCode": "+228"
  },
  {
    "name": "Tokelau",
    "Iso2": "tk",
    "callingCode": "+690"
  },
  {
    "name": "Tonga",
    "Iso2": "to",
    "callingCode": "+676"
  },
  {
    "name": "Trinidad and Tobago",
    "Iso2": "tt",
    "callingCode": "+1868"
  },
  {
    "name": "Tunisia",
    "Iso2": "tn",
    "callingCode": "+216"
  },
  {
    "name": "Turkey",
    "Iso2": "tr",
    "callingCode": "+90"
  },
  {
    "name": "Turkmenistan",
    "Iso2": "tm",
    "callingCode": "+993"
  },
  {
    "name": "Tuvalu",
    "Iso2": "tv",
    "callingCode": "+688"
  },
  {
    "name": "U.S. Virgin Islands",
    "Iso2": "vi",
    "callingCode": "+1340"
  },
  {
    "name": "Uganda",
    "Iso2": "ug",
    "callingCode": "+256"
  },
  {
    "name": "Ukraine",
    "Iso2": "ua",
    "callingCode": "+380"
  },
  {
    "name": "United Arab Emirates",
    "Iso2": "ae",
    "callingCode": "+971"
  },
  {
    "name": "United Kingdom",
    "Iso2": "gb",
    "callingCode": "+44"
  },
  {
    "name": "United States",
    "Iso2": "us",
    "callingCode": "+1"
  },
  {
    "name": "Uruguay",
    "Iso2": "uy",
    "callingCode": "+598"
  },
  {
    "name": "Uzbekistan",
    "Iso2": "uz",
    "callingCode": "+998"
  },
  {
    "name": "Vanuatu",
    "Iso2": "vu",
    "callingCode": "+678"
  },
  {
    "name": "Vatican City",
    "Iso2": "va",
    "callingCode": "+39"
  },
  {
    "name": "Venezuela",
    "Iso2": "ve",
    "callingCode": "+58"
  },
  {
    "name": "Vietnam",
    "Iso2": "vn",
    "callingCode": "+84"
  },
  {
    "name": "Wallis and Futuna",
    "Iso2": "wf",
    "callingCode": "+681"
  },
  {
    "name": "Western Sahara",
    "Iso2": "eh",
    "callingCode": "+212"
  },
  {
    "name": "Yemen",
    "Iso2": "ye",
    "callingCode": "+967"
  },
  {
    "name": "Zambia",
    "Iso2": "zm",
    "callingCode": "+260"
  },
  {
    "name": "Zimbabwe",
    "Iso2": "zw",
    "callingCode": "263"
  }
];

export const CountriesAndState = [
  {
    "name": "Afghanistan",
    "states": [
      "Badakhshan",
      "Badghis",
      "Baghlan",
      "Balkh",
      "Bamyan",
      "Daykundi",
      "Farah",
      "Faryab",
      "Ghazni",
      "Ghōr",
      "Helmand",
      "Herat",
      "Jowzjan",
      "Kabul",
      "Kandahar",
      "Kapisa",
      "Khost",
      "Kunar",
      "Kunduz Province",
      "Laghman",
      "Logar",
      "Nangarhar",
      "Nimruz",
      "Nuristan",
      "Paktia",
      "Paktika",
      "Panjshir",
      "Parwan",
      "Samangan",
      "Sar-e Pol",
      "Takhar",
      "Urozgan",
      "Zabul"
    ]
  },
  {
    "name": "Aland Islands",
    "states": [
      "Brändö",
      "Eckerö",
      "Finström",
      "Föglö",
      "Geta",
      "Hammarland",
      "Jomala",
      "Kökar",
      "Kumlinge",
      "Lemland",
      "Lumparland",
      "Mariehamn",
      "Saltvik",
      "Sottunga",
      "Sund",
      "Vårdö"
    ]
  },
  {
    "name": "Albania",
    "states": [
      "Berat",
      "Berat",
      "Bulqizë",
      "Delvinë",
      "Devoll",
      "Dibër",
      "Dibër",
      "Durrës",
      "Durrës",
      "Elbasan",
      "Fier",
      "Fier",
      "Gjirokastër",
      "Gjirokastër",
      "Gramsh",
      "Has",
      "Kavajë",
      "Kolonjë",
      "Korçë",
      "Korçë",
      "Krujë",
      "Kuçovë",
      "Kukës",
      "Kukës",
      "Kurbin",
      "Lezhë",
      "Lezhë",
      "Librazhd",
      "Lushnjë",
      "Malësi e Madhe",
      "Mallakastër",
      "Mat",
      "Mirditë",
      "Peqin",
      "Përmet",
      "Pogradec",
      "Pukë",
      "Sarandë",
      "Shkodër",
      "Shkodër",
      "Skrapar",
      "Tepelenë",
      "Tirana",
      "Tirana",
      "Tropojë",
      "Vlorë",
      "Vlorë"
    ]
  },
  {
    "name": "Algeria",
    "states": [
      "Adrar",
      "Aïn Defla",
      "Aïn Témouchent",
      "Algiers",
      "Annaba",
      "Batna",
      "Béchar",
      "Béjaïa",
      "Béni Abbès",
      "Biskra",
      "Blida",
      "Bordj Baji Mokhtar",
      "Bordj Bou Arréridj",
      "Bouïra",
      "Boumerdès",
      "Chlef",
      "Constantine",
      "Djanet",
      "Djelfa",
      "El Bayadh",
      "El M'ghair",
      "El Menia",
      "El Oued",
      "El Tarf",
      "Ghardaïa",
      "Guelma",
      "Illizi",
      "In Guezzam",
      "In Salah",
      "Jijel",
      "Khenchela",
      "Laghouat",
      "M'Sila",
      "Mascara",
      "Médéa",
      "Mila",
      "Mostaganem",
      "Naama",
      "Oran",
      "Ouargla",
      "Ouled Djellal",
      "Oum El Bouaghi",
      "Relizane",
      "Saïda",
      "Sétif",
      "Sidi Bel Abbès",
      "Skikda",
      "Souk Ahras",
      "Tamanghasset",
      "Tébessa",
      "Tiaret",
      "Timimoun",
      "Tindouf",
      "Tipasa",
      "Tissemsilt",
      "Tizi Ouzou",
      "Tlemcen",
      "Touggourt"
    ]
  },
  {
    "name": "American Samoa",
    "states": [
      "Eastern",
      "Manuʻa",
      "Rose",
      "Swains",
      "Western"
    ]
  },
  {
    "name": "Andorra",
    "states": [
      "Andorra la Vella",
      "Canillo",
      "Encamp",
      "Escaldes-Engordany",
      "La Massana",
      "Ordino",
      "Sant Julià de Lòria"
    ]
  },
  {
    "name": "Angola",
    "states": [
      "Bengo",
      "Benguela",
      "Bié",
      "Cabinda",
      "Cuando Cubango",
      "Cuanza",
      "Cuanza Norte",
      "Cunene",
      "Huambo",
      "Huíla",
      "Luanda",
      "Lunda Norte",
      "Lunda Sul",
      "Malanje",
      "Moxico",
      "Uíge",
      "Zaire"
    ]
  },
  {
    "name": "Anguilla",
    "states": [
      "Blowing Point",
      "East End",
      "George Hill",
      "Island Harbour",
      "North Hill",
      "North Side",
      "Sandy Ground",
      "Sandy Hill",
      "South Hill",
      "Stoney Ground",
      "The Farrington",
      "The Quarter",
      "The Valley",
      "West End"
    ]
  },
  {
    "name": "Antarctica",
    "states": []
  },
  {
    "name": "Antigua and Barbuda",
    "states": [
      "Barbuda",
      "Redonda",
      "Saint George",
      "Saint John",
      "Saint Mary",
      "Saint Paul",
      "Saint Peter",
      "Saint Philip"
    ]
  },
  {
    "name": "Argentina",
    "states": [
      "Autonomous City of Buenos Aires",
      "Buenos Aires",
      "Catamarca",
      "Chaco",
      "Chubut",
      "Córdoba",
      "Corrientes",
      "Entre Ríos",
      "Formosa",
      "Jujuy",
      "La Pampa",
      "La Rioja",
      "Mendoza",
      "Misiones",
      "Neuquén",
      "Río Negro",
      "Salta",
      "San Juan",
      "San Luis",
      "Santa Cruz",
      "Santa Fe",
      "Santiago del Estero",
      "Tierra del Fuego",
      "Tucumán"
    ]
  },
  {
    "name": "Armenia",
    "states": [
      "Aragatsotn",
      "Ararat",
      "Armavir",
      "Gegharkunik",
      "Kotayk",
      "Lori",
      "Shirak",
      "Syunik",
      "Tavush",
      "Vayots Dzor",
      "Yerevan"
    ]
  },
  {
    "name": "Aruba",
    "states": [
      "Noord",
      "Oranjestad",
      "Oranjestad East",
      "Oranjestad West",
      "Paradera",
      "San Nicolaas Noord",
      "San Nicolaas Zuid",
      "Santa Cruz",
      "Savaneta"
    ]
  },
  {
    "name": "Australia",
    "states": [
      "Australian Capital Territory",
      "New South Wales",
      "Northern Territory",
      "Queensland",
      "South Australia",
      "Tasmania",
      "Victoria",
      "Western Australia"
    ]
  },
  {
    "name": "Austria",
    "states": [
      "Burgenland",
      "Carinthia",
      "Lower Austria",
      "Salzburg",
      "Styria",
      "Tyrol",
      "Upper Austria",
      "Vienna",
      "Vorarlberg"
    ]
  },
  {
    "name": "Azerbaijan",
    "states": [
      "Absheron",
      "Agdam",
      "Agdash",
      "Aghjabadi",
      "Agstafa",
      "Agsu",
      "Astara",
      "Babek",
      "Baku",
      "Balakan",
      "Barda",
      "Beylagan",
      "Bilasuvar",
      "Dashkasan",
      "Fizuli",
      "Ganja",
      "Gədəbəy",
      "Gobustan",
      "Goranboy",
      "Goychay",
      "Goygol",
      "Hajigabul",
      "Imishli",
      "Ismailli",
      "Jabrayil",
      "Jalilabad",
      "Julfa",
      "Kalbajar",
      "Kangarli",
      "Khachmaz",
      "Khizi",
      "Khojali",
      "Kurdamir",
      "Lachin",
      "Lankaran",
      "Lankaran",
      "Lerik",
      "Martuni",
      "Masally",
      "Mingachevir",
      "Nakhchivan",
      "Neftchala",
      "Oghuz",
      "Ordubad",
      "Qabala",
      "Qakh",
      "Qazakh",
      "Quba",
      "Qubadli",
      "Qusar",
      "Saatly",
      "Sabirabad",
      "Sadarak",
      "Salyan",
      "Samukh",
      "Shabran",
      "Shahbuz",
      "Shaki",
      "Shaki",
      "Shamakhi",
      "Shamkir",
      "Sharur",
      "Shirvan",
      "Shusha",
      "Siazan",
      "Sumqayit",
      "Tartar",
      "Tovuz",
      "Ujar",
      "Yardymli",
      "Yevlakh",
      "Yevlakh",
      "Zangilan",
      "Zaqatala",
      "Zardab"
    ]
  },
  {
    "name": "Bahrain",
    "states": [
      "Capital",
      "Central",
      "Muharraq",
      "Northern",
      "Southern"
    ]
  },
  {
    "name": "Bangladesh",
    "states": [
      "Barisal ",
      "Chittagong ",
      "Dhaka ",
      "Khulna ",
      "Mymensingh ",
      "Rajshahi ",
      "Rangpur ",
      "Sylhet "
    ]
  },
  {
    "name": "Barbados",
    "states": [
      "Christ Church",
      "Saint Andrew",
      "Saint George",
      "Saint James",
      "Saint John",
      "Saint Joseph",
      "Saint Lucy",
      "Saint Michael",
      "Saint Peter",
      "Saint Philip",
      "Saint Thomas"
    ]
  },
  {
    "name": "Belarus",
    "states": [
      "Brest",
      "Gomel",
      "Grodno",
      "Minsk",
      "Minsk",
      "Mogilev",
      "Vitebsk"
    ]
  },
  {
    "name": "Belgium",
    "states": [
      "Antwerp",
      "Brussels-Capital ",
      "East Flanders",
      "Flanders",
      "Flemish Brabant",
      "Hainaut",
      "Liège",
      "Limburg",
      "Luxembourg",
      "Namur",
      "Wallonia",
      "Walloon Brabant",
      "West Flanders"
    ]
  },
  {
    "name": "Belize",
    "states": [
      "Belize",
      "Cayo",
      "Corozal",
      "Orange Walk",
      "Stann Creek",
      "Toledo"
    ]
  },
  {
    "name": "Benin",
    "states": [
      "Alibori",
      "Atakora",
      "Atlantique",
      "Borgou",
      "Collines",
      "Donga",
      "Kouffo",
      "Littoral",
      "Mono",
      "Ouémé",
      "Plateau",
      "Zou"
    ]
  },
  {
    "name": "Bermuda",
    "states": [
      "Devonshire",
      "Hamilton",
      "Paget",
      "Pembroke",
      "Saint George's",
      "Sandys",
      "Smith's",
      "Southampton",
      "Warwick"
    ]
  },
  {
    "name": "Bhutan",
    "states": [
      "Bumthang ",
      "Chukha ",
      "Dagana ",
      "Gasa ",
      "Haa ",
      "Lhuntse ",
      "Mongar ",
      "Paro ",
      "Pemagatshel ",
      "Punakha ",
      "Samdrup Jongkhar ",
      "Samtse ",
      "Sarpang ",
      "Thimphu ",
      "Trashi Yangtse\t",
      "Trashigang ",
      "Trongsa ",
      "Tsirang ",
      "Wangdue Phodrang ",
      "Zhemgang "
    ]
  },
  {
    "name": "Bolivia",
    "states": [
      "Beni",
      "Chuquisaca",
      "Cochabamba",
      "La Paz",
      "Oruro",
      "Pando",
      "Potosí",
      "Santa Cruz",
      "Tarija"
    ]
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "states": [
      "Bonaire",
      "Saba",
      "Sint Eustatius"
    ]
  },
  {
    "name": "Bosnia and Herzegovina",
    "states": [
      "Bosnian Podrinje",
      "Brčko",
      "Canton 10",
      "Central Bosnia",
      "Federation of Bosnia and Herzegovina",
      "Herzegovina-Neretva",
      "Posavina",
      "Republika Srpska",
      "Sarajevo",
      "Tuzla",
      "Una-Sana",
      "West Herzegovina",
      "Zenica-Doboj"
    ]
  },
  {
    "name": "Botswana",
    "states": [
      "Central",
      "Ghanzi",
      "Kgalagadi",
      "Kgatleng",
      "Kweneng",
      "Ngamiland",
      "North-East",
      "North-West",
      "South-East",
      "Southern"
    ]
  },
  {
    "name": "Bouvet Island",
    "states": []
  },
  {
    "name": "Brazil",
    "states": [
      "Acre",
      "Alagoas",
      "Amapá",
      "Amazonas",
      "Bahia",
      "Ceará",
      "Distrito Federal",
      "Espírito Santo",
      "Goiás",
      "Maranhão",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Pará",
      "Paraíba",
      "Paraná",
      "Pernambuco",
      "Piauí",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rondônia",
      "Roraima",
      "Santa Catarina",
      "São Paulo",
      "Sergipe",
      "Tocantins"
    ]
  },
  {
    "name": "British Indian Ocean Territory",
    "states": []
  },
  {
    "name": "Brunei",
    "states": [
      "Belait",
      "Brunei-Muara",
      "Temburong",
      "Tutong"
    ]
  },
  {
    "name": "Bulgaria",
    "states": [
      "Blagoevgrad",
      "Burgas",
      "Dobrich",
      "Gabrovo",
      "Haskovo",
      "Kardzhali",
      "Kyustendil",
      "Lovech",
      "Montana",
      "Pazardzhik",
      "Pernik",
      "Pleven",
      "Plovdiv",
      "Razgrad",
      "Ruse",
      "Shumen",
      "Silistra",
      "Sliven",
      "Smolyan",
      "Sofia",
      "Sofia City",
      "Stara Zagora",
      "Targovishte",
      "Varna",
      "Veliko Tarnovo",
      "Vidin",
      "Vratsa",
      "Yambol"
    ]
  },
  {
    "name": "Burkina Faso",
    "states": [
      "Balé",
      "Bam",
      "Banwa",
      "Bazèga",
      "Boucle du Mouhoun",
      "Bougouriba",
      "Boulgou",
      "Boulkiemde",
      "Cascades",
      "Centre",
      "Centre-Est",
      "Centre-Nord",
      "Centre-Ouest",
      "Centre-Sud",
      "Comoé",
      "Est",
      "Ganzourgou",
      "Gnagna",
      "Gourma",
      "Hauts-Bassins",
      "Houet",
      "Ioba",
      "Kadiogo",
      "Kénédougou",
      "Komondjari",
      "Kompienga",
      "Kossi",
      "Koulpélogo",
      "Kouritenga",
      "Kourwéogo",
      "Léraba",
      "Loroum",
      "Mouhoun",
      "Nahouri",
      "Namentenga",
      "Nayala",
      "Nord",
      "Noumbiel",
      "Oubritenga",
      "Oudalan",
      "Passoré",
      "Plateau-Central",
      "Poni",
      "Sahel",
      "Sanguié",
      "Sanmatenga",
      "Séno",
      "Sissili",
      "Soum",
      "Sourou",
      "Sud-Ouest",
      "Tapoa",
      "Tuy",
      "Yagha",
      "Yatenga",
      "Ziro",
      "Zondoma",
      "Zoundwéogo"
    ]
  },
  {
    "name": "Burundi",
    "states": [
      "Bubanza",
      "Bujumbura Mairie",
      "Bujumbura Rural",
      "Bururi",
      "Cankuzo",
      "Cibitoke",
      "Gitega",
      "Karuzi",
      "Kayanza",
      "Kirundo",
      "Makamba",
      "Muramvya",
      "Muyinga",
      "Mwaro",
      "Ngozi",
      "Rumonge",
      "Rutana",
      "Ruyigi"
    ]
  },
  {
    "name": "Cambodia",
    "states": [
      "Banteay Meanchey",
      "Battambang",
      "Kampong Cham",
      "Kampong Chhnang",
      "Kampong Speu",
      "Kampong Thom",
      "Kampot",
      "Kandal",
      "Kep",
      "Koh Kong",
      "Kratie",
      "Mondulkiri",
      "Oddar Meanchey",
      "Pailin",
      "Phnom Penh",
      "Preah Vihear",
      "Prey Veng",
      "Pursat",
      "Ratanakiri",
      "Siem Reap",
      "Sihanoukville",
      "Stung Treng",
      "Svay Rieng",
      "Takeo"
    ]
  },
  {
    "name": "Cameroon",
    "states": [
      "Adamawa",
      "Centre",
      "East",
      "Far North",
      "Littoral",
      "North",
      "Northwest",
      "South",
      "Southwest",
      "West"
    ]
  },
  {
    "name": "Canada",
    "states": [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland and Labrador",
      "Northwest Territories",
      "Nova Scotia",
      "Nunavut",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan",
      "Yukon"
    ]
  },
  {
    "name": "Cape Verde",
    "states": [
      "Barlavento Islands",
      "Boa Vista",
      "Brava",
      "Maio",
      "Mosteiros",
      "Paul",
      "Porto Novo",
      "Praia",
      "Ribeira Brava",
      "Ribeira Grande",
      "Ribeira Grande de Santiago",
      "Sal",
      "Santa Catarina",
      "Santa Catarina do Fogo",
      "Santa Cruz",
      "São Domingos",
      "São Filipe",
      "São Lourenço dos Órgãos",
      "São Miguel",
      "São Vicente",
      "Sotavento Islands",
      "Tarrafal",
      "Tarrafal de São Nicolau"
    ]
  },
  {
    "name": "Cayman Islands",
    "states": [
      "Cayman Brac",
      "Grand Cayman",
      "Little Cayman"
    ]
  },
  {
    "name": "Central African Republic",
    "states": [
      "Bamingui-Bangoran",
      "Bangui",
      "Basse-Kotto",
      "Haut-Mbomou",
      "Haute-Kotto",
      "Kémo",
      "Lobaye",
      "Mambéré-Kadéï",
      "Mbomou",
      "Nana-Grébizi",
      "Nana-Mambéré",
      "Ombella-M'Poko",
      "Ouaka",
      "Ouham",
      "Ouham-Pendé",
      "Sangha-Mbaéré",
      "Vakaga"
    ]
  },
  {
    "name": "Chad",
    "states": [
      "Bahr el Gazel",
      "Batha",
      "Borkou",
      "Chari-Baguirmi",
      "Ennedi-Est",
      "Ennedi-Ouest",
      "Guéra",
      "Hadjer-Lamis",
      "Kanem",
      "Lac",
      "Logone Occidental",
      "Logone Oriental",
      "Mandoul",
      "Mayo-Kebbi Est",
      "Mayo-Kebbi Ouest",
      "Moyen-Chari",
      "N'Djamena",
      "Ouaddaï",
      "Salamat",
      "Sila",
      "Tandjilé",
      "Tibesti",
      "Wadi Fira"
    ]
  },
  {
    "name": "Chile",
    "states": [
      "Aisén del General Carlos Ibañez del Campo",
      "Antofagasta",
      "Arica y Parinacota",
      "Atacama",
      "Biobío",
      "Coquimbo",
      "La Araucanía",
      "Libertador General Bernardo O'Higgins",
      "Los Lagos",
      "Los Ríos",
      "Magallanes y de la Antártica Chilena",
      "Maule",
      "Ñuble",
      "Región Metropolitana de Santiago",
      "Tarapacá",
      "Valparaíso"
    ]
  },
  {
    "name": "China",
    "states": [
      "Anhui",
      "Beijing",
      "Chongqing",
      "Fujian",
      "Gansu",
      "Guangdong",
      "Guangxi Zhuang",
      "Guizhou",
      "Hainan",
      "Hebei",
      "Heilongjiang",
      "Henan",
      "Hong Kong SAR",
      "Hubei",
      "Hunan",
      "Inner Mongolia",
      "Jiangsu",
      "Jiangxi",
      "Jilin",
      "Liaoning",
      "Macau SAR",
      "Ningxia Huizu",
      "Qinghai",
      "Shaanxi",
      "Shandong",
      "Shanghai",
      "Shanxi",
      "Sichuan",
      "Taiwan",
      "Tianjin",
      "Xinjiang",
      "Xizang",
      "Yunnan",
      "Zhejiang"
    ]
  },
  {
    "name": "Christmas Island",
    "states": []
  },
  {
    "name": "Cocos (Keeling) Islands",
    "states": []
  },
  {
    "name": "Colombia",
    "states": [
      "Amazonas",
      "Antioquia",
      "Arauca",
      "Atlántico",
      "Bogotá D.C.",
      "Bolívar",
      "Boyacá",
      "Caldas",
      "Caquetá",
      "Casanare",
      "Cauca",
      "Cesar",
      "Chocó",
      "Córdoba",
      "Cundinamarca",
      "Guainía",
      "Guaviare",
      "Huila",
      "La Guajira",
      "Magdalena",
      "Meta",
      "Nariño",
      "Norte de Santander",
      "Putumayo",
      "Quindío",
      "Risaralda",
      "San Andrés, Providencia y Santa Catalina",
      "Santander",
      "Sucre",
      "Tolima",
      "Valle del Cauca",
      "Vaupés",
      "Vichada"
    ]
  },
  {
    "name": "Comoros",
    "states": [
      "Anjouan",
      "Grande Comore",
      "Mohéli"
    ]
  },
  {
    "name": "Congo",
    "states": [
      "Bouenza",
      "Brazzaville",
      "Cuvette",
      "Cuvette-Ouest",
      "Kouilou",
      "Lékoumou",
      "Likouala",
      "Niari",
      "Plateaux",
      "Pointe-Noire",
      "Pool",
      "Sangha"
    ]
  },
  {
    "name": "Cook Islands",
    "states": []
  },
  {
    "name": "Costa Rica",
    "states": [
      "Alajuela",
      "Cartago",
      "Guanacaste",
      "Heredia",
      "Limón",
      "Puntarenas",
      "San José"
    ]
  },
  {
    "name": "Cote D'Ivoire (Ivory Coast)",
    "states": [
      "Abidjan",
      "Agnéby",
      "Bafing",
      "Bas-Sassandra",
      "Comoé",
      "Denguélé",
      "Dix-Huit Montagnes",
      "Fromager",
      "Gôh-Djiboua",
      "Haut-Sassandra",
      "Lacs",
      "Lagunes",
      "Marahoué",
      "Montagnes",
      "Moyen-Cavally",
      "Moyen-Comoé",
      "N'zi-Comoé",
      "Sassandra-Marahoué",
      "Savanes",
      "Sud-Bandama",
      "Sud-Comoé",
      "Vallée du Bandama",
      "Woroba",
      "Worodougou",
      "Yamoussoukro",
      "Zanzan"
    ]
  },
  {
    "name": "Croatia",
    "states": [
      "Bjelovar-Bilogora",
      "Brod-Posavina",
      "Dubrovnik-Neretva",
      "Istria",
      "Karlovac",
      "Koprivnica-Križevci",
      "Krapina-Zagorje",
      "Lika-Senj",
      "Međimurje",
      "Osijek-Baranja",
      "Požega-Slavonia",
      "Primorje-Gorski Kotar",
      "Šibenik-Knin",
      "Sisak-Moslavina",
      "Split-Dalmatia",
      "Varaždin",
      "Virovitica-Podravina",
      "Vukovar-Syrmia",
      "Zadar",
      "Zagreb",
      "Zagreb"
    ]
  },
  {
    "name": "Cuba",
    "states": [
      "Artemisa",
      "Camagüey",
      "Ciego de Ávila",
      "Cienfuegos",
      "Granma",
      "Guantánamo",
      "Havana",
      "Holguín",
      "Isla de la Juventud",
      "Las Tunas",
      "Matanzas",
      "Mayabeque",
      "Pinar del Río",
      "Sancti Spíritus",
      "Santiago de Cuba",
      "Villa Clara"
    ]
  },
  {
    "name": "Curaçao",
    "states": []
  },
  {
    "name": "Cyprus",
    "states": [
      "Famagusta (Mağusa)",
      "Kyrenia (Keryneia)",
      "Larnaca (Larnaka)",
      "Limassol (Leymasun)",
      "Nicosia (Lefkoşa)",
      "Paphos (Pafos)"
    ]
  },
  {
    "name": "Czech Republic",
    "states": [
      "Benešov",
      "Beroun",
      "Blansko",
      "Břeclav",
      "Brno-město",
      "Brno-venkov",
      "Bruntál",
      "Česká Lípa",
      "České Budějovice",
      "Český Krumlov",
      "Cheb",
      "Chomutov",
      "Chrudim",
      "Děčín",
      "Domažlice",
      "Frýdek-Místek",
      "Havlíčkův Brod",
      "Hodonín",
      "Hradec Králové",
      "Jablonec nad Nisou",
      "Jeseník",
      "Jičín",
      "Jihlava",
      "Jihočeský kraj",
      "Jihomoravský kraj",
      "Jindřichův Hradec",
      "Karlovarský kraj",
      "Karlovy Vary",
      "Karviná",
      "Kladno",
      "Klatovy",
      "Kolín",
      "Kraj Vysočina",
      "Královéhradecký kraj",
      "Kroměříž",
      "Kutná Hora",
      "Liberec",
      "Liberecký kraj",
      "Litoměřice",
      "Louny",
      "Mělník",
      "Mladá Boleslav",
      "Moravskoslezský kraj",
      "Most",
      "Náchod",
      "Nový Jičín",
      "Nymburk",
      "Olomouc",
      "Olomoucký kraj",
      "Opava",
      "Ostrava-město",
      "Pardubice",
      "Pardubický kraj",
      "Pelhřimov",
      "Písek",
      "Plzeň-jih",
      "Plzeň-město",
      "Plzeň-sever",
      "Plzeňský kraj",
      "Prachatice",
      "Praha-východ",
      "Praha-západ",
      "Praha, Hlavní město",
      "Přerov",
      "Příbram",
      "Prostějov",
      "Rakovník",
      "Rokycany",
      "Rychnov nad Kněžnou",
      "Semily",
      "Sokolov",
      "Strakonice",
      "Středočeský kraj",
      "Šumperk",
      "Svitavy",
      "Tábor",
      "Tachov",
      "Teplice",
      "Třebíč",
      "Trutnov",
      "Uherské Hradiště",
      "Ústecký kraj",
      "Ústí nad Labem",
      "Ústí nad Orlicí",
      "Vsetín",
      "Vyškov",
      "Žďár nad Sázavou",
      "Zlín",
      "Zlínský kraj",
      "Znojmo"
    ]
  },
  {
    "name": "Democratic Republic of the Congo",
    "states": [
      "Bas-Uélé",
      "Équateur",
      "Haut-Katanga",
      "Haut-Lomami",
      "Haut-Uélé",
      "Ituri",
      "Kasaï",
      "Kasaï Central",
      "Kasaï Oriental",
      "Kinshasa",
      "Kongo Central",
      "Kwango",
      "Kwilu",
      "Lomami",
      "Lualaba",
      "Mai-Ndombe",
      "Maniema",
      "Mongala",
      "Nord-Kivu",
      "Nord-Ubangi",
      "Sankuru",
      "Sud-Kivu",
      "Sud-Ubangi",
      "Tanganyika",
      "Tshopo",
      "Tshuapa"
    ]
  },
  {
    "name": "Denmark",
    "states": [
      "Central Denmark",
      "Denmark",
      "North Denmark",
      "Southern Denmark",
      "Zealand"
    ]
  },
  {
    "name": "Djibouti",
    "states": [
      "Ali Sabieh",
      "Arta",
      "Dikhil",
      "Djibouti",
      "Obock",
      "Tadjourah"
    ]
  },
  {
    "name": "Dominica",
    "states": [
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint John",
      "Saint Joseph",
      "Saint Luke",
      "Saint Mark",
      "Saint Patrick",
      "Saint Paul",
      "Saint Peter"
    ]
  },
  {
    "name": "Dominican Republic",
    "states": [
      "Azua",
      "Baoruco",
      "Barahona",
      "Dajabón",
      "Distrito Nacional",
      "Duarte",
      "El Seibo",
      "Espaillat",
      "Hato Mayor",
      "Hermanas Mirabal",
      "Independencia",
      "La Altagracia",
      "La Romana",
      "La Vega",
      "María Trinidad Sánchez",
      "Monseñor Nouel",
      "Monte Cristi",
      "Monte Plata",
      "Pedernales",
      "Peravia",
      "Puerto Plata",
      "Samaná",
      "San Cristóbal",
      "San José de Ocoa",
      "San Juan",
      "San Pedro de Macorís",
      "Sánchez Ramírez",
      "Santiago",
      "Santiago Rodríguez",
      "Santo Domingo",
      "Valverde"
    ]
  },
  {
    "name": "Ecuador",
    "states": [
      "Azuay",
      "Bolívar",
      "Cañar",
      "Carchi",
      "Chimborazo",
      "Cotopaxi",
      "El Oro",
      "Esmeraldas",
      "Galápagos",
      "Guayas",
      "Imbabura",
      "Loja",
      "Los Ríos",
      "Manabí",
      "Morona-Santiago",
      "Napo",
      "Orellana",
      "Pastaza",
      "Pichincha",
      "Santa Elena",
      "Santo Domingo de los Tsáchilas",
      "Sucumbíos",
      "Tungurahua",
      "Zamora Chinchipe"
    ]
  },
  {
    "name": "Egypt",
    "states": [
      "Alexandria",
      "Aswan",
      "Asyut",
      "Beheira",
      "Beni Suef",
      "Cairo",
      "Dakahlia",
      "Damietta",
      "Faiyum",
      "Gharbia",
      "Giza",
      "Ismailia",
      "Kafr El-Sheikh",
      "Luxor",
      "Matrouh",
      "Minya",
      "Monufia",
      "New Valley",
      "North Sinai",
      "Port Said",
      "Qalyubia",
      "Qena",
      "Red Sea",
      "Sharqia",
      "Sohag",
      "South Sinai",
      "Suez"
    ]
  },
  {
    "name": "El Salvador",
    "states": [
      "Ahuachapán",
      "Cabañas",
      "Chalatenango",
      "Cuscatlán",
      "La Libertad",
      "La Paz",
      "La Unión ",
      "Morazán",
      "San Miguel",
      "San Salvador",
      "San Vicente",
      "Santa Ana",
      "Sonsonate",
      "Usulután"
    ]
  },
  {
    "name": "Equatorial Guinea",
    "states": [
      "Annobón",
      "Bioko Norte",
      "Bioko Sur",
      "Centro Sur",
      "Insular",
      "Kié-Ntem",
      "Litoral",
      "Río Muni",
      "Wele-Nzas"
    ]
  },
  {
    "name": "Eritrea",
    "states": [
      "Anseba",
      "Debub",
      "Gash-Barka",
      "Maekel",
      "Northern Red Sea",
      "Southern Red Sea"
    ]
  },
  {
    "name": "Estonia",
    "states": [
      "Harju",
      "Hiiu",
      "Ida-Viru",
      "Järva",
      "Jõgeva",
      "Lääne",
      "Lääne-Viru",
      "Pärnu",
      "Põlva",
      "Rapla",
      "Saare",
      "Tartu",
      "Valga",
      "Viljandi",
      "Võru"
    ]
  },
  {
    "name": "Eswatini",
    "states": [
      "Hhohho",
      "Lubombo",
      "Manzini",
      "Shiselweni"
    ]
  },
  {
    "name": "Ethiopia",
    "states": [
      "Addis Ababa",
      "Afar",
      "Amhara",
      "Benishangul-Gumuz",
      "Dire Dawa",
      "Gambela",
      "Harari",
      "Oromia",
      "Somali",
      "Southern Nations, Nationalities, and Peoples'",
      "Tigray"
    ]
  },
  {
    "name": "Falkland Islands",
    "states": []
  },
  {
    "name": "Faroe Islands",
    "states": [
      "Eysturoy",
      "Northern Isles",
      "Sandoy",
      "Streymoy",
      "Suðuroy",
      "Vágar"
    ]
  },
  {
    "name": "Fiji Islands",
    "states": [
      "Ba",
      "Bua",
      "Cakaudrove",
      "Central",
      "Eastern",
      "Kadavu",
      "Lau",
      "Lomaiviti",
      "Macuata",
      "Nadroga-Navosa",
      "Naitasiri",
      "Namosi",
      "Northern",
      "Ra",
      "Rewa",
      "Rotuma",
      "Serua",
      "Tailevu",
      "Western"
    ]
  },
  {
    "name": "Finland",
    "states": [
      "Åland Islands",
      "Central Finland",
      "Central Ostrobothnia",
      "Finland Proper",
      "Kainuu",
      "Kymenlaakso",
      "Lapland",
      "North Karelia",
      "Northern Ostrobothnia",
      "Northern Savonia",
      "Ostrobothnia",
      "Päijänne Tavastia",
      "Pirkanmaa",
      "Satakunta",
      "South Karelia",
      "Southern Ostrobothnia",
      "Southern Savonia",
      "Tavastia Proper",
      "Uusimaa"
    ]
  },
  {
    "name": "France",
    "states": [
      "Ain",
      "Aisne",
      "Allier",
      "Alpes-de-Haute-Provence",
      "Alpes-Maritimes",
      "Alsace",
      "Ardèche",
      "Ardennes",
      "Ariège",
      "Aube",
      "Aude",
      "Auvergne-Rhône-Alpes",
      "Aveyron",
      "Bas-Rhin",
      "Bouches-du-Rhône",
      "Bourgogne-Franche-Comté",
      "Bretagne",
      "Calvados",
      "Cantal",
      "Centre-Val de Loire",
      "Charente",
      "Charente-Maritime",
      "Cher",
      "Clipperton",
      "Corrèze",
      "Corse",
      "Corse-du-Sud",
      "Côte-d'Or",
      "Côtes-d'Armor",
      "Creuse",
      "Deux-Sèvres",
      "Dordogne",
      "Doubs",
      "Drôme",
      "Essonne",
      "Eure",
      "Eure-et-Loir",
      "Finistère",
      "French Guiana",
      "French Polynesia",
      "French Southern and Antarctic Lands",
      "Gard",
      "Gers",
      "Gironde",
      "Grand-Est",
      "Guadeloupe",
      "Haut-Rhin",
      "Haute-Corse",
      "Haute-Garonne",
      "Haute-Loire",
      "Haute-Marne",
      "Haute-Saône",
      "Haute-Savoie",
      "Haute-Vienne",
      "Hautes-Alpes",
      "Hautes-Pyrénées",
      "Hauts-de-France",
      "Hauts-de-Seine",
      "Hérault",
      "Île-de-France",
      "Ille-et-Vilaine",
      "Indre",
      "Indre-et-Loire",
      "Isère",
      "Jura",
      "La Réunion",
      "Landes",
      "Loir-et-Cher",
      "Loire",
      "Loire-Atlantique",
      "Loiret",
      "Lot",
      "Lot-et-Garonne",
      "Lozère",
      "Maine-et-Loire",
      "Manche",
      "Marne",
      "Martinique",
      "Mayenne",
      "Mayotte",
      "Métropole de Lyon",
      "Meurthe-et-Moselle",
      "Meuse",
      "Morbihan",
      "Moselle",
      "Nièvre",
      "Nord",
      "Normandie",
      "Nouvelle-Aquitaine",
      "Occitanie",
      "Oise",
      "Orne",
      "Paris",
      "Pas-de-Calais",
      "Pays-de-la-Loire",
      "Provence-Alpes-Côte-d’Azur",
      "Puy-de-Dôme",
      "Pyrénées-Atlantiques",
      "Pyrénées-Orientales",
      "Rhône",
      "Saint Pierre and Miquelon",
      "Saint-Barthélemy",
      "Saint-Martin",
      "Saône-et-Loire",
      "Sarthe",
      "Savoie",
      "Seine-et-Marne",
      "Seine-Maritime",
      "Seine-Saint-Denis",
      "Somme",
      "Tarn",
      "Tarn-et-Garonne",
      "Territoire de Belfort",
      "Val-d'Oise",
      "Val-de-Marne",
      "Var",
      "Vaucluse",
      "Vendée",
      "Vienne",
      "Vosges",
      "Wallis and Futuna",
      "Yonne",
      "Yvelines"
    ]
  },
  {
    "name": "French Guiana",
    "states": []
  },
  {
    "name": "French Polynesia",
    "states": [
      "Austral Islands",
      "Leeward Islands",
      "Marquesas Islands",
      "Tuamotu-Gambier",
      "Windward Islands"
    ]
  },
  {
    "name": "French Southern Territories",
    "states": []
  },
  {
    "name": "Gabon",
    "states": [
      "Estuaire",
      "Haut-Ogooué",
      "Moyen-Ogooué",
      "Ngounié",
      "Nyanga",
      "Ogooué-Ivindo",
      "Ogooué-Lolo",
      "Ogooué-Maritime",
      "Woleu-Ntem"
    ]
  },
  {
    "name": "Georgia",
    "states": [
      "Abkhazia",
      "Adjara",
      "Guria",
      "Imereti",
      "Kakheti",
      "Kvemo Kartli",
      "Mtskheta-Mtianeti",
      "Racha-Lechkhumi and Kvemo Svaneti",
      "Samegrelo-Zemo Svaneti",
      "Samtskhe-Javakheti",
      "Shida Kartli",
      "Tbilisi"
    ]
  },
  {
    "name": "Germany",
    "states": [
      "Baden-Württemberg",
      "Bavaria",
      "Berlin",
      "Brandenburg",
      "Bremen",
      "Hamburg",
      "Hessen",
      "Lower Saxony",
      "Mecklenburg-Vorpommern",
      "North Rhine-Westphalia",
      "Rhineland-Palatinate",
      "Saarland",
      "Saxony",
      "Saxony-Anhalt",
      "Schleswig-Holstein",
      "Thuringia"
    ]
  },
  {
    "name": "Ghana",
    "states": [
      "Ahafo",
      "Ashanti",
      "Bono",
      "Bono East",
      "Central",
      "Eastern",
      "Greater Accra",
      "North East",
      "Northern",
      "Oti",
      "Savannah",
      "Upper East",
      "Upper West",
      "Volta",
      "Western",
      "Western North"
    ]
  },
  {
    "name": "Gibraltar",
    "states": []
  },
  {
    "name": "Greece",
    "states": [
      "Achaea",
      "Aetolia-Acarnania",
      "Arcadia",
      "Argolis",
      "Attica",
      "Boeotia",
      "Central Greece",
      "Central Macedonia",
      "Chania",
      "Corfu",
      "Corinthia",
      "Crete",
      "Drama",
      "East Attica",
      "East Macedonia and Thrace",
      "Epirus",
      "Euboea",
      "Grevena",
      "Imathia ",
      "Ioannina",
      "Ionian Islands",
      "Karditsa",
      "Kastoria",
      "Kefalonia",
      "Kilkis",
      "Kozani",
      "Laconia",
      "Larissa",
      "Lefkada",
      "Pella",
      "Peloponnese",
      "Phthiotis",
      "Preveza",
      "Serres",
      "South Aegean",
      "Thessaloniki",
      "West Greece",
      "West Macedonia"
    ]
  },
  {
    "name": "Greenland",
    "states": [
      "Avannaata",
      "Kujalleq",
      "Qeqertalik",
      "Qeqqata",
      "Sermersooq"
    ]
  },
  {
    "name": "Grenada",
    "states": [
      "Carriacou",
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint John",
      "Saint Mark",
      "Saint Patrick"
    ]
  },
  {
    "name": "Guadeloupe",
    "states": [
      "Basse-Terre",
      "Pointe-à-Pitre"
    ]
  },
  {
    "name": "Guam",
    "states": [
      "Agana Heights",
      "Asan-Maina",
      "Barrigada",
      "Chalan Pago-Ordot",
      "Dededo",
      "Hågat",
      "Hagåtña",
      "Inarajan (Inalåhan)",
      "Mangilao",
      "Merizo (Malesso)",
      "Mongmong-Toto-Maite",
      "Piti",
      "Santa Rita (Sånta Rita-Sumai)",
      "Sinajana",
      "Talofofo (Talo'fo'fo)",
      "Tamuning",
      "Umatac (Humåtak)",
      "Yigo",
      "Yona"
    ]
  },
  {
    "name": "Guatemala",
    "states": [
      "Alta Verapaz ",
      "Baja Verapaz ",
      "Chimaltenango ",
      "Chiquimula ",
      "El Progreso ",
      "Escuintla ",
      "Guatemala ",
      "Huehuetenango ",
      "Izabal ",
      "Jalapa ",
      "Jutiapa ",
      "Petén ",
      "Quetzaltenango ",
      "Quiché ",
      "Retalhuleu ",
      "Sacatepéquez ",
      "San Marcos ",
      "Santa Rosa ",
      "Sololá ",
      "Suchitepéquez ",
      "Totonicapán ",
      "Zacapa"
    ]
  },
  {
    "name": "Guernsey",
    "states": [
      "Alderney",
      "Castel",
      "Forest",
      "Sark",
      "St Andrew",
      "St Martin",
      "St Peter Port",
      "St Pierre du Bois",
      "St Sampson",
      "St Saviour",
      "Torteval",
      "Vale"
    ]
  },
  {
    "name": "Guinea",
    "states": [
      "Beyla",
      "Boffa",
      "Boké",
      "Boké",
      "Conakry",
      "Coyah",
      "Dabola",
      "Dalaba",
      "Dinguiraye",
      "Dubréka",
      "Faranah",
      "Faranah",
      "Forécariah",
      "Fria",
      "Gaoual",
      "Guéckédou",
      "Kankan",
      "Kankan",
      "Kérouané",
      "Kindia",
      "Kindia",
      "Kissidougou",
      "Koubia",
      "Koundara",
      "Kouroussa",
      "Labé",
      "Labé",
      "Lélouma",
      "Lola",
      "Macenta",
      "Mali",
      "Mamou",
      "Mamou",
      "Mandiana",
      "Nzérékoré",
      "Nzérékoré",
      "Pita",
      "Siguiri",
      "Télimélé",
      "Tougué",
      "Yomou"
    ]
  },
  {
    "name": "Guinea-Bissau",
    "states": [
      "Bafatá",
      "Biombo",
      "Bolama",
      "Cacheu",
      "Gabú",
      "Leste",
      "Norte",
      "Oio",
      "Quinara",
      "Sul",
      "Tombali"
    ]
  },
  {
    "name": "Guyana",
    "states": [
      "Barima-Waini",
      "Cuyuni-Mazaruni",
      "Demerara-Mahaica",
      "East Berbice-Corentyne",
      "Essequibo Islands-West Demerara",
      "Mahaica-Berbice",
      "Pomeroon-Supenaam",
      "Potaro-Siparuni",
      "Upper Demerara-Berbice",
      "Upper Takutu-Upper Essequibo"
    ]
  },
  {
    "name": "Haiti",
    "states": [
      "Artibonite",
      "Centre",
      "Grand'Anse",
      "Nippes",
      "Nord",
      "Nord-Est",
      "Nord-Ouest",
      "Ouest",
      "Sud",
      "Sud-Est"
    ]
  },
  {
    "name": "Heard Island and McDonald Islands",
    "states": []
  },
  {
    "name": "Honduras",
    "states": [
      "Atlántida",
      "Bay Islands",
      "Choluteca",
      "Colón",
      "Comayagua",
      "Copán",
      "Cortés",
      "El Paraíso",
      "Francisco Morazán",
      "Gracias a Dios",
      "Intibucá",
      "La Paz",
      "Lempira",
      "Ocotepeque",
      "Olancho",
      "Santa Bárbara",
      "Valle",
      "Yoro"
    ]
  },
  {
    "name": "Hong Kong S.A.R.",
    "states": [
      "Central and Western",
      "Eastern",
      "Islands",
      "Kowloon City",
      "Kwai Tsing",
      "Kwun Tong",
      "North",
      "Sai Kung",
      "Sha Tin",
      "Sham Shui Po",
      "Southern",
      "Tai Po",
      "Tsuen Wan",
      "Tuen Mun",
      "Wan Chai",
      "Wong Tai Sin",
      "Yau Tsim Mong",
      "Yuen Long"
    ]
  },
  {
    "name": "Hungary",
    "states": [
      "Bács-Kiskun",
      "Baranya",
      "Békés",
      "Békéscsaba",
      "Borsod-Abaúj-Zemplén",
      "Budapest",
      "Csongrád County",
      "Debrecen",
      "Dunaújváros",
      "Eger",
      "Érd",
      "Fejér County",
      "Győr",
      "Győr-Moson-Sopron County",
      "Hajdú-Bihar County",
      "Heves County",
      "Hódmezővásárhely",
      "Jász-Nagykun-Szolnok County",
      "Kaposvár",
      "Kecskemét",
      "Komárom-Esztergom",
      "Miskolc",
      "Nagykanizsa",
      "Nógrád County",
      "Nyíregyháza",
      "Pécs",
      "Pest County",
      "Salgótarján",
      "Somogy County",
      "Sopron",
      "Szabolcs-Szatmár-Bereg County",
      "Szeged",
      "Székesfehérvár",
      "Szekszárd",
      "Szolnok",
      "Szombathely",
      "Tatabánya",
      "Tolna County",
      "Vas County",
      "Veszprém",
      "Veszprém County",
      "Zala County",
      "Zalaegerszeg"
    ]
  },
  {
    "name": "Iceland",
    "states": [
      "Capital",
      "Eastern",
      "Northeastern",
      "Northwestern",
      "Southern",
      "Southern Peninsula",
      "Western",
      "Westfjords"
    ]
  },
  {
    "name": "India",
    "states": [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Dadra and Nagar Haveli and Daman and Diu",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu and Kashmir",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Lakshadweep",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Puducherry",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal"
    ]
  },
  {
    "name": "Indonesia",
    "states": [
      "Aceh",
      "Bali",
      "Banten",
      "Bengkulu",
      "DI Yogyakarta",
      "DKI Jakarta",
      "Gorontalo",
      "Jambi",
      "Jawa Barat",
      "Jawa Tengah",
      "Jawa Timur",
      "Kalimantan Barat",
      "Kalimantan Selatan",
      "Kalimantan Tengah",
      "Kalimantan Timur",
      "Kalimantan Utara",
      "Kepulauan Bangka Belitung",
      "Kepulauan Riau",
      "Lampung",
      "Maluku",
      "Maluku Utara",
      "Nusa Tenggara Barat",
      "Nusa Tenggara Timur",
      "Papua",
      "Papua Barat",
      "Papua Barat Daya",
      "Papua Pegunungan",
      "Papua Selatan",
      "Papua Tengah",
      "Riau",
      "Sulawesi Barat",
      "Sulawesi Selatan",
      "Sulawesi Tengah",
      "Sulawesi Tenggara",
      "Sulawesi Utara",
      "Sumatera Barat",
      "Sumatera Selatan",
      "Sumatera Utara"
    ]
  },
  {
    "name": "Iran",
    "states": [
      "Alborz",
      "Ardabil",
      "Bushehr",
      "Chaharmahal and Bakhtiari",
      "East Azerbaijan",
      "Fars",
      "Gilan",
      "Golestan",
      "Hamadan",
      "Hormozgan",
      "Ilam",
      "Isfahan",
      "Kerman",
      "Kermanshah",
      "Khuzestan",
      "Kohgiluyeh and Boyer-Ahmad",
      "Kurdistan",
      "Lorestan",
      "Markazi",
      "Mazandaran",
      "North Khorasan",
      "Qazvin",
      "Qom",
      "Razavi Khorasan",
      "Semnan",
      "Sistan and Baluchestan",
      "South Khorasan",
      "Tehran",
      "West Azarbaijan",
      "Yazd",
      "Zanjan"
    ]
  },
  {
    "name": "Iraq",
    "states": [
      "Al Anbar",
      "Al Muthanna",
      "Al-Qādisiyyah",
      "Babylon",
      "Baghdad",
      "Basra",
      "Dhi Qar",
      "Diyala",
      "Dohuk",
      "Erbil",
      "Karbala",
      "Kirkuk",
      "Maysan",
      "Najaf",
      "Nineveh",
      "Saladin",
      "Sulaymaniyah",
      "Wasit"
    ]
  },
  {
    "name": "Ireland",
    "states": [
      "Carlow",
      "Cavan",
      "Clare",
      "Connacht",
      "Cork",
      "Donegal",
      "Dublin",
      "Galway",
      "Kerry",
      "Kildare",
      "Kilkenny",
      "Laois",
      "Leinster",
      "Leitrim",
      "Limerick",
      "Longford",
      "Louth",
      "Mayo",
      "Meath",
      "Monaghan",
      "Munster",
      "Offaly",
      "Roscommon",
      "Sligo",
      "Tipperary",
      "Ulster",
      "Waterford",
      "Westmeath",
      "Wexford",
      "Wicklow"
    ]
  },
  {
    "name": "Israel",
    "states": [
      "Central",
      "Haifa",
      "Jerusalem",
      "Northern",
      "Southern",
      "Tel Aviv"
    ]
  },
  {
    "name": "Italy",
    "states": [
      "Abruzzo",
      "Agrigento",
      "Alessandria",
      "Ancona",
      "Aosta Valley",
      "Apulia",
      "Arezzo",
      "Ascoli Piceno",
      "Asti",
      "Avellino",
      "Barletta-Andria-Trani",
      "Basilicata",
      "Belluno",
      "Benevento",
      "Bergamo",
      "Biella",
      "Brescia",
      "Brindisi",
      "Calabria",
      "Caltanissetta",
      "Campania",
      "Campobasso",
      "Caserta",
      "Catanzaro",
      "Chieti",
      "Como",
      "Cosenza",
      "Cremona",
      "Crotone",
      "Cuneo",
      "Emilia-Romagna",
      "Enna",
      "Fermo",
      "Ferrara",
      "Foggia",
      "Forlì-Cesena",
      "Friuli–Venezia Giulia",
      "Frosinone",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "L'Aquila",
      "La Spezia",
      "Latina",
      "Lazio",
      "Lecce",
      "Lecco",
      "Liguria",
      "Livorno",
      "Lodi",
      "Lombardy",
      "Lucca",
      "Macerata",
      "Mantua",
      "Marche",
      "Massa and Carrara",
      "Matera",
      "Modena",
      "Molise",
      "Monza and Brianza",
      "Novara",
      "Nuoro",
      "Oristano",
      "Padua",
      "Palermo",
      "Parma",
      "Pavia",
      "Perugia",
      "Pesaro and Urbino",
      "Pescara",
      "Piacenza",
      "Piedmont",
      "Pisa",
      "Pistoia",
      "Pordenone",
      "Potenza",
      "Prato",
      "Ragusa",
      "Ravenna",
      "Reggio Emilia",
      "Rieti",
      "Rimini",
      "Rovigo",
      "Salerno",
      "Sardinia",
      "Sassari",
      "Savona",
      "Sicily",
      "Siena",
      "Siracusa",
      "Sondrio",
      "South Sardinia",
      "Taranto",
      "Teramo",
      "Terni",
      "Trapani",
      "Trentino-South Tyrol",
      "Treviso",
      "Trieste",
      "Tuscany",
      "Udine",
      "Umbria",
      "Varese",
      "Veneto",
      "Verbano-Cusio-Ossola",
      "Vercelli",
      "Verona",
      "Vibo Valentia",
      "Vicenza",
      "Viterbo"
    ]
  },
  {
    "name": "Jamaica",
    "states": [
      "Clarendon",
      "Hanover",
      "Kingston",
      "Manchester",
      "Portland",
      "Saint Andrew",
      "Saint Ann",
      "Saint Catherine",
      "Saint Elizabeth",
      "Saint James",
      "Saint Mary",
      "Saint Thomas",
      "Trelawny",
      "Westmoreland"
    ]
  },
  {
    "name": "Japan",
    "states": [
      "Aichi",
      "Akita",
      "Aomori",
      "Chiba",
      "Ehime",
      "Fukui",
      "Fukuoka",
      "Fukushima",
      "Gifu",
      "Gunma",
      "Hiroshima",
      "Hokkaidō",
      "Hyōgo",
      "Ibaraki",
      "Ishikawa",
      "Iwate",
      "Kagawa",
      "Kagoshima",
      "Kanagawa",
      "Kōchi",
      "Kumamoto",
      "Kyōto",
      "Mie",
      "Miyagi",
      "Miyazaki",
      "Nagano",
      "Nagasaki",
      "Nara",
      "Niigata",
      "Ōita",
      "Okayama",
      "Okinawa",
      "Ōsaka",
      "Saga",
      "Saitama",
      "Shiga",
      "Shimane",
      "Shizuoka",
      "Tochigi",
      "Tokushima",
      "Tokyo",
      "Tottori",
      "Toyama",
      "Wakayama",
      "Yamagata",
      "Yamaguchi",
      "Yamanashi"
    ]
  },
  {
    "name": "Jersey",
    "states": [
      "Grouville",
      "St Brelade",
      "St Clement",
      "St Helier",
      "St John",
      "St Lawrence",
      "St Martin",
      "St Mary",
      "St Ouen",
      "St Peter",
      "St Saviour",
      "Trinity"
    ]
  },
  {
    "name": "Jordan",
    "states": [
      "Ajloun",
      "Amman",
      "Aqaba",
      "Balqa",
      "Irbid",
      "Jerash",
      "Karak",
      "Ma'an",
      "Madaba",
      "Mafraq",
      "Tafilah",
      "Zarqa"
    ]
  },
  {
    "name": "Kazakhstan",
    "states": [
      "Abai",
      "Akmola",
      "Aktobe",
      "Almaty",
      "Almaty",
      "Astana",
      "Atyrau",
      "East Kazakhstan",
      "Jambyl",
      "Jetisu",
      "Karaganda",
      "Kostanay",
      "Kyzylorda",
      "Mangystau",
      "North Kazakhstan",
      "Pavlodar",
      "Shymkent",
      "Turkistan",
      "Ulytau",
      "West Kazakhstan"
    ]
  },
  {
    "name": "Kenya",
    "states": [
      "Baringo",
      "Bomet",
      "Bungoma",
      "Busia",
      "Elgeyo-Marakwet",
      "Embu",
      "Garissa",
      "Homa Bay",
      "Isiolo",
      "Kajiado",
      "Kakamega",
      "Kericho",
      "Kiambu",
      "Kilifi",
      "Kirinyaga",
      "Kisii",
      "Kisumu",
      "Kitui",
      "Kwale",
      "Laikipia",
      "Lamu",
      "Machakos",
      "Makueni",
      "Mandera",
      "Marsabit",
      "Meru",
      "Migori",
      "Mombasa",
      "Murang'a",
      "Nairobi City",
      "Nakuru",
      "Nandi",
      "Narok",
      "Nyamira",
      "Nyandarua",
      "Nyeri",
      "Samburu",
      "Siaya",
      "Taita–Taveta",
      "Tana River",
      "Tharaka-Nithi",
      "Trans Nzoia",
      "Turkana",
      "Uasin Gishu",
      "Vihiga",
      "Wajir",
      "West Pokot"
    ]
  },
  {
    "name": "Kiribati",
    "states": [
      "Gilbert",
      "Line",
      "Phoenix"
    ]
  },
  {
    "name": "Kosovo",
    "states": [
      "Ferizaj",
      "Gjakove",
      "Gjilan",
      "Mitrovica",
      "Peja",
      "Pristina",
      "Prizren"
    ]
  },
  {
    "name": "Kuwait",
    "states": [
      "Al Ahmadi",
      "Al Asimah",
      "Al Farwaniyah",
      "Al Jahra",
      "Hawalli",
      "Mubarak Al-Kabeer"
    ]
  },
  {
    "name": "Kyrgyzstan",
    "states": [
      "Batken",
      "Bishkek",
      "Chuy",
      "Issyk-Kul",
      "Jalal-Abad",
      "Naryn",
      "Osh",
      "Osh",
      "Talas"
    ]
  },
  {
    "name": "Laos",
    "states": [
      "Attapeu",
      "Bokeo",
      "Bolikhamsai",
      "Champasak",
      "Houaphanh",
      "Khammouane",
      "Luang Namtha",
      "Luang Prabang",
      "Oudomxay",
      "Phongsaly",
      "Sainyabuli",
      "Salavan",
      "Savannakhet",
      "Sekong",
      "Vientiane",
      "Vientiane",
      "Xaisomboun",
      "Xiangkhouang"
    ]
  },
  {
    "name": "Latvia",
    "states": [
      "Ādaži",
      "Aizkraukle",
      "Alūksne",
      "Augšdaugava",
      "Balvi",
      "Bauska",
      "Cēsis",
      "Daugavpils",
      "Dienvidkurzemes",
      "Dobele",
      "Gulbene",
      "Jēkabpils",
      "Jelgava",
      "Jelgava",
      "Jūrmala",
      "Ķekava",
      "Krāslava",
      "Kuldīga",
      "Liepāja",
      "Limbaži",
      "Līvāni",
      "Ludza",
      "Madona",
      "Mārupe",
      "Ogre",
      "Olaine",
      "Preiļi",
      "Rēzekne",
      "Rēzekne",
      "Riga",
      "Ropaži",
      "Salaspils",
      "Saldus",
      "Saulkrasti",
      "Sigulda",
      "Smiltene",
      "Talsi",
      "Tukums",
      "Valka",
      "Valmiera",
      "Varakļāni",
      "Ventspils",
      "Ventspils"
    ]
  },
  {
    "name": "Lebanon",
    "states": [
      "Akkar",
      "Baalbek-Hermel",
      "Beirut",
      "Beqaa",
      "Mount Lebanon",
      "Nabatieh",
      "North",
      "South"
    ]
  },
  {
    "name": "Lesotho",
    "states": [
      "Berea",
      "Butha-Buthe",
      "Leribe",
      "Mafeteng",
      "Maseru",
      "Mohale's Hoek",
      "Mokhotlong",
      "Qacha's Nek",
      "Quthing",
      "Thaba-Tseka"
    ]
  },
  {
    "name": "Liberia",
    "states": [
      "Bomi",
      "Bong",
      "Gbarpolu",
      "Grand Bassa",
      "Grand Cape Mount",
      "Grand Gedeh",
      "Grand Kru",
      "Lofa",
      "Margibi",
      "Maryland",
      "Montserrado",
      "Nimba",
      "River Cess",
      "River Gee",
      "Sinoe"
    ]
  },
  {
    "name": "Libya",
    "states": [
      "Al Wahat",
      "Benghazi",
      "Derna",
      "Ghat",
      "Jabal al Akhdar",
      "Jabal al Gharbi",
      "Jafara",
      "Jufra",
      "Kufra",
      "Marj",
      "Misrata",
      "Murqub",
      "Murzuq",
      "Nalut",
      "Nuqat al Khams",
      "Sabha",
      "Sirte",
      "Tripoli",
      "Wadi al Hayaa",
      "Wadi al Shatii",
      "Zawiya"
    ]
  },
  {
    "name": "Liechtenstein",
    "states": [
      "Balzers",
      "Eschen",
      "Gamprin",
      "Mauren",
      "Planken",
      "Ruggell",
      "Schaan",
      "Schellenberg",
      "Triesen",
      "Triesenberg",
      "Vaduz"
    ]
  },
  {
    "name": "Lithuania",
    "states": [
      "Akmenė",
      "Alytus",
      "Alytus",
      "Anykščiai",
      "Birštonas",
      "Biržai",
      "Druskininkai",
      "Elektrėnai",
      "Ignalina",
      "Jonava",
      "Joniškis",
      "Jurbarkas",
      "Kaišiadorys",
      "Kalvarija",
      "Kaunas",
      "Kaunas",
      "Kazlų Rūda",
      "Kėdainiai",
      "Kelmė",
      "Klaipėda",
      "Klaipėda",
      "Kretinga",
      "Kupiškis",
      "Lazdijai",
      "Marijampolė",
      "Marijampolė",
      "Mažeikiai",
      "Molėtai",
      "Neringa",
      "Pagėgiai",
      "Pakruojis",
      "Palanga",
      "Panevėžys",
      "Panevėžys",
      "Pasvalys",
      "Plungė",
      "Prienai",
      "Radviliškis",
      "Raseiniai",
      "Rietavas",
      "Rokiškis",
      "Šakiai",
      "Šalčininkai",
      "Šiauliai",
      "Šiauliai",
      "Šilalė ",
      "Šilutė",
      "Širvintos",
      "Skuodas",
      "Švenčionys",
      "Tauragė",
      "Tauragė",
      "Telšiai",
      "Telšiai",
      "Trakai",
      "Ukmergė",
      "Utena",
      "Utena",
      "Varėna",
      "Vilkaviškis",
      "Vilnius",
      "Vilnius",
      "Visaginas",
      "Zarasai"
    ]
  },
  {
    "name": "Luxembourg",
    "states": [
      "Capellen",
      "Clervaux",
      "Diekirch",
      "Echternach",
      "Esch-sur-Alzette",
      "Grevenmacher",
      "Luxembourg ",
      "Mersch",
      "Redange",
      "Remich",
      "Vianden",
      "Wiltz"
    ]
  },
  {
    "name": "Macau S.A.R.",
    "states": []
  },
  {
    "name": "Madagascar",
    "states": [
      "Antananarivo",
      "Antsiranana",
      "Fianarantsoa",
      "Mahajanga",
      "Toamasina",
      "Toliara"
    ]
  },
  {
    "name": "Malawi",
    "states": [
      "Balaka",
      "Blantyre",
      "Central",
      "Chikwawa",
      "Chiradzulu",
      "Chitipa",
      "Dedza",
      "Dowa",
      "Karonga",
      "Kasungu",
      "Likoma",
      "Lilongwe",
      "Machinga",
      "Mangochi",
      "Mchinji",
      "Mulanje",
      "Mwanza",
      "Mzimba",
      "Neno",
      "Nkhata Bay",
      "Nkhotakota",
      "Northern",
      "Nsanje",
      "Ntcheu",
      "Ntchisi",
      "Phalombe",
      "Rumphi",
      "Salima",
      "Southern",
      "Thyolo",
      "Zomba"
    ]
  },
  {
    "name": "Malaysia",
    "states": [
      "Johor",
      "Kedah",
      "Kelantan",
      "Kuala Lumpur",
      "Labuan",
      "Malacca",
      "Negeri Sembilan",
      "Pahang",
      "Penang",
      "Perak",
      "Perlis",
      "Putrajaya",
      "Sabah",
      "Sarawak",
      "Selangor",
      "Terengganu"
    ]
  },
  {
    "name": "Maldives",
    "states": [
      "Addu",
      "Alif Alif",
      "Alif Dhaal",
      "Central",
      "Dhaalu",
      "Faafu",
      "Gaafu Alif",
      "Gaafu Dhaalu",
      "Gnaviyani",
      "Haa Alif",
      "Haa Dhaalu",
      "Kaafu",
      "Laamu",
      "Lhaviyani",
      "Malé",
      "Meemu",
      "Noonu",
      "North Central",
      "Raa",
      "Shaviyani",
      "South",
      "South Central",
      "Thaa",
      "Upper South",
      "Vaavu"
    ]
  },
  {
    "name": "Mali",
    "states": [
      "Bamako",
      "Gao",
      "Kayes",
      "Kidal",
      "Koulikoro",
      "Ménaka",
      "Mopti",
      "Ségou",
      "Sikasso",
      "Taoudénit",
      "Tombouctou"
    ]
  },
  {
    "name": "Malta",
    "states": [
      "Attard",
      "Balzan",
      "Birgu",
      "Birkirkara",
      "Birżebbuġa",
      "Cospicua",
      "Dingli",
      "Fgura",
      "Floriana",
      "Fontana",
      "Għajnsielem",
      "Għarb",
      "Għargħur",
      "Għasri",
      "Għaxaq",
      "Gudja",
      "Gżira",
      "Ħamrun",
      "Iklin",
      "Kalkara",
      "Kerċem",
      "Kirkop",
      "Lija",
      "Luqa",
      "Marsa",
      "Marsaskala",
      "Marsaxlokk",
      "Mdina",
      "Mellieħa",
      "Mġarr",
      "Mosta",
      "Mqabba",
      "Msida",
      "Mtarfa",
      "Munxar",
      "Nadur",
      "Naxxar",
      "Paola",
      "Pembroke",
      "Pietà",
      "Qala",
      "Qormi",
      "Qrendi",
      "Rabat",
      "San Ġwann",
      "San Lawrenz",
      "Sannat",
      "Santa Luċija",
      "Santa Venera",
      "Senglea",
      "Siġġiewi",
      "Sliema",
      "St. Julian's",
      "St. Paul's Bay",
      "Swieqi",
      "Ta' Xbiex",
      "Tarxien",
      "Valletta",
      "Victoria",
      "Xagħra",
      "Xewkija",
      "Xgħajra",
      "Żabbar",
      "Żebbuġ Gozo",
      "Żebbuġ Malta",
      "Żejtun",
      "Żurrieq"
    ]
  },
  {
    "name": "Man (Isle of)",
    "states": [
      "Ayre",
      "Garff",
      "Glenfaba",
      "Michael",
      "Middle",
      "Rushen"
    ]
  },
  {
    "name": "Marshall Islands",
    "states": [
      "Ralik",
      "Ratak"
    ]
  },
  {
    "name": "Martinique",
    "states": [
      "Fort-de-France",
      "La Trinité",
      "Le Marin",
      "Saint-Pierre"
    ]
  },
  {
    "name": "Mauritania",
    "states": [
      "Adrar",
      "Assaba",
      "Brakna",
      "Dakhlet Nouadhibou",
      "Gorgol",
      "Guidimaka",
      "Hodh Ech Chargui",
      "Hodh El Gharbi",
      "Inchiri",
      "Nouakchott-Nord",
      "Nouakchott-Ouest",
      "Nouakchott-Sud",
      "Tagant",
      "Tiris Zemmour",
      "Trarza"
    ]
  },
  {
    "name": "Mauritius",
    "states": [
      "Agalega Islands",
      "Black River",
      "Flacq",
      "Grand Port",
      "Moka",
      "Pamplemousses",
      "Plaines Wilhems",
      "Port Louis",
      "Rivière du Rempart",
      "Rodrigues Island",
      "Saint Brandon Islands",
      "Savanne"
    ]
  },
  {
    "name": "Mayotte",
    "states": [
      "Acoua",
      "Bandraboua",
      "Bandrélé",
      "Boueni",
      "Chiconi",
      "Chirongui",
      "Dembeni",
      "Dzaoudzi",
      "Kani Keli",
      "Koungou",
      "M'Tsangamouji",
      "Mamoudzou",
      "Mtsamboro",
      "Ouangani",
      "Pamandzi",
      "Sada",
      "Tsingoni"
    ]
  },
  {
    "name": "Mexico",
    "states": [
      "Aguascalientes",
      "Baja California",
      "Baja California Sur",
      "Campeche",
      "Chiapas",
      "Chihuahua",
      "Ciudad de México",
      "Coahuila de Zaragoza",
      "Colima",
      "Durango",
      "Estado de México",
      "Guanajuato",
      "Guerrero",
      "Hidalgo",
      "Jalisco",
      "Michoacán de Ocampo",
      "Morelos",
      "Nayarit",
      "Nuevo León",
      "Oaxaca",
      "Puebla",
      "Querétaro",
      "Quintana Roo",
      "San Luis Potosí",
      "Sinaloa",
      "Sonora",
      "Tabasco",
      "Tamaulipas",
      "Tlaxcala",
      "Veracruz de Ignacio de la Llave",
      "Yucatán",
      "Zacatecas"
    ]
  },
  {
    "name": "Micronesia",
    "states": [
      "Chuuk",
      "Kosrae",
      "Pohnpei",
      "Yap"
    ]
  },
  {
    "name": "Moldova",
    "states": [
      "Anenii Noi",
      "Bălți",
      "Basarabeasca",
      "Bender",
      "Briceni",
      "Cahul",
      "Călărași",
      "Cantemir",
      "Căușeni",
      "Chișinău",
      "Cimișlia",
      "Criuleni",
      "Dondușeni",
      "Drochia",
      "Dubăsari",
      "Edineț",
      "Fălești",
      "Florești",
      "Gagauzia",
      "Glodeni",
      "Hîncești",
      "Ialoveni",
      "Nisporeni",
      "Ocnița",
      "Orhei",
      "Rezina",
      "Rîșcani",
      "Sîngerei",
      "Șoldănești",
      "Soroca",
      "Ștefan Vodă",
      "Strășeni",
      "Taraclia",
      "Telenești",
      "Transnistria",
      "Ungheni"
    ]
  },
  {
    "name": "Monaco",
    "states": [
      "La Colle",
      "La Condamine",
      "Moneghetti"
    ]
  },
  {
    "name": "Mongolia",
    "states": [
      "Arkhangai",
      "Bayan-Ölgii",
      "Bayankhongor",
      "Bulgan",
      "Darkhan-Uul",
      "Dornod",
      "Dornogovi",
      "Dundgovi",
      "Govi-Altai",
      "Govisümber",
      "Khentii",
      "Khovd",
      "Khövsgöl",
      "Ömnögovi",
      "Orkhon",
      "Övörkhangai",
      "Selenge",
      "Sükhbaatar",
      "Töv",
      "Ulaanbaatar",
      "Uvs",
      "Zavkhan"
    ]
  },
  {
    "name": "Montenegro",
    "states": [
      "Andrijevica",
      "Bar",
      "Berane",
      "Bijelo Polje",
      "Budva",
      "Danilovgrad",
      "Gusinje",
      "Kolašin",
      "Kotor",
      "Mojkovac",
      "Nikšić",
      "Old Royal Capital Cetinje",
      "Petnjica",
      "Plav",
      "Pljevlja",
      "Plužine",
      "Podgorica",
      "Rožaje",
      "Šavnik",
      "Tivat",
      "Ulcinj",
      "Žabljak"
    ]
  },
  {
    "name": "Montserrat",
    "states": [
      "Saint Anthony",
      "Saint Georges",
      "Saint Peter"
    ]
  },
  {
    "name": "Morocco",
    "states": [
      "Agadir-Ida-Ou-Tanane",
      "Al Haouz",
      "Al Hoceïma",
      "Aousserd (EH)",
      "Assa-Zag (EH-partial)",
      "Azilal",
      "Béni Mellal",
      "Béni Mellal-Khénifra",
      "Benslimane",
      "Berkane",
      "Berrechid",
      "Boujdour (EH)",
      "Boulemane",
      "Casablanca",
      "Casablanca-Settat",
      "Chefchaouen",
      "Chichaoua",
      "Chtouka-Ait Baha",
      "Dakhla-Oued Ed-Dahab (EH)",
      "Drâa-Tafilalet",
      "Driouch",
      "El Hajeb",
      "El Jadida",
      "El Kelâa des Sraghna",
      "Errachidia",
      "Es-Semara (EH-partial)",
      "Essaouira",
      "Fahs-Anjra",
      "Fès",
      "Fès-Meknès",
      "Figuig",
      "Fquih Ben Salah",
      "Guelmim",
      "Guelmim-Oued Noun (EH-partial)",
      "Guercif",
      "Ifrane",
      "Inezgane-Ait Melloul",
      "Jerada",
      "Kénitra",
      "Khémisset",
      "Khénifra",
      "Khouribga",
      "L'Oriental",
      "Laâyoune (EH)",
      "Laâyoune-Sakia El Hamra (EH-partial)",
      "Larache",
      "M’diq-Fnideq",
      "Marrakech",
      "Marrakesh-Safi",
      "Médiouna",
      "Meknès",
      "Midelt",
      "Mohammadia",
      "Moulay Yacoub",
      "Nador",
      "Nouaceur",
      "Ouarzazate",
      "Oued Ed-Dahab (EH)",
      "Ouezzane",
      "Oujda-Angad",
      "Rabat",
      "Rabat-Salé-Kénitra",
      "Rehamna",
      "Safi",
      "Salé",
      "Sefrou",
      "Settat",
      "Sidi Bennour",
      "Sidi Ifni",
      "Sidi Kacem",
      "Sidi Slimane",
      "Skhirate-Témara",
      "Souss-Massa",
      "Tan-Tan (EH-partial)",
      "Tanger-Assilah",
      "Tanger-Tétouan-Al Hoceïma",
      "Taounate",
      "Taourirt",
      "Tarfaya (EH-partial)",
      "Taroudannt",
      "Tata",
      "Taza",
      "Tétouan",
      "Tinghir",
      "Tiznit",
      "Youssoufia",
      "Zagora"
    ]
  },
  {
    "name": "Mozambique",
    "states": [
      "Cabo Delgado",
      "Gaza",
      "Inhambane",
      "Manica",
      "Maputo",
      "Maputo",
      "Nampula",
      "Niassa",
      "Sofala",
      "Tete",
      "Zambezia"
    ]
  },
  {
    "name": "Myanmar",
    "states": [
      "Ayeyarwady",
      "Bago",
      "Chin",
      "Kachin",
      "Kayah",
      "Kayin",
      "Magway",
      "Mandalay",
      "Mon State",
      "Naypyidaw",
      "Rakhine",
      "Sagaing",
      "Shan",
      "Tanintharyi",
      "Yangon"
    ]
  },
  {
    "name": "Namibia",
    "states": [
      "Erongo",
      "Hardap",
      "Karas",
      "Kavango East",
      "Kavango West",
      "Khomas",
      "Kunene",
      "Ohangwena",
      "Omaheke",
      "Omusati",
      "Oshana",
      "Oshikoto",
      "Otjozondjupa",
      "Zambezi"
    ]
  },
  {
    "name": "Nauru",
    "states": [
      "Aiwo",
      "Anabar",
      "Anetan",
      "Anibare",
      "Baiti",
      "Boe",
      "Buada",
      "Denigomodu",
      "Ewa",
      "Ijuw",
      "Meneng",
      "Nibok",
      "Uaboe",
      "Yaren"
    ]
  },
  {
    "name": "Nepal",
    "states": [
      "Bagmati",
      "Gandaki",
      "Karnali",
      "Koshi",
      "Lumbini",
      "Madhesh",
      "Sudurpashchim"
    ]
  },
  {
    "name": "Netherlands",
    "states": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "North Brabant",
      "North Holland",
      "Overijssel",
      "South Holland",
      "Utrecht",
      "Zeeland"
    ]
  },
  {
    "name": "New Caledonia",
    "states": [
      "Loyalty Islands Province",
      "North Province",
      "South Province"
    ]
  },
  {
    "name": "New Zealand",
    "states": [
      "Auckland",
      "Bay of Plenty",
      "Canterbury",
      "Chatham Islands",
      "Gisborne",
      "Hawke's Bay",
      "Manawatu-Wanganui",
      "Marlborough",
      "Nelson",
      "Northland",
      "Otago",
      "Southland",
      "Taranaki",
      "Tasman",
      "Waikato",
      "Wellington",
      "West Coast"
    ]
  },
  {
    "name": "Nicaragua",
    "states": [
      "Boaco",
      "Carazo",
      "Chinandega",
      "Chontales",
      "Estelí",
      "Granada",
      "Jinotega",
      "León",
      "Madriz",
      "Managua",
      "Masaya",
      "Matagalpa",
      "North Caribbean Coast",
      "Nueva Segovia",
      "Río San Juan",
      "Rivas",
      "South Caribbean Coast"
    ]
  },
  {
    "name": "Niger",
    "states": [
      "Agadez",
      "Diffa",
      "Dosso",
      "Maradi",
      "Tahoua",
      "Tillabéri",
      "Zinder"
    ]
  },
  {
    "name": "Nigeria",
    "states": [
      "Abia",
      "Abuja Federal Capital Territory",
      "Adamawa",
      "Akwa Ibom",
      "Anambra",
      "Bauchi",
      "Bayelsa",
      "Benue",
      "Borno",
      "Cross River",
      "Delta",
      "Ebonyi",
      "Edo",
      "Ekiti",
      "Enugu",
      "Gombe",
      "Imo",
      "Jigawa",
      "Kaduna",
      "Kano",
      "Katsina",
      "Kebbi",
      "Kogi",
      "Kwara",
      "Lagos",
      "Nasarawa",
      "Niger",
      "Ogun",
      "Ondo",
      "Osun",
      "Oyo",
      "Plateau",
      "Rivers",
      "Sokoto",
      "Taraba",
      "Yobe",
      "Zamfara"
    ]
  },
  {
    "name": "Niue",
    "states": [
      "Alofi North",
      "Alofi South",
      "Avatele",
      "Hakupu",
      "Hikutavake",
      "Lakepa",
      "Liku",
      "Makefu",
      "Mutalau",
      "Namukulu",
      "Tamakautoga",
      "Toi",
      "Tuapa",
      "Vaiea"
    ]
  },
  {
    "name": "Norfolk Island",
    "states": []
  },
  {
    "name": "North Korea",
    "states": [
      "Chagang",
      "Kangwon",
      "North Hamgyong",
      "North Hwanghae",
      "North Pyongan",
      "Pyongyang",
      "Rason",
      "Ryanggang",
      "South Hamgyong",
      "South Hwanghae",
      "South Pyongan"
    ]
  },
  {
    "name": "North Macedonia",
    "states": [
      "Aerodrom",
      "Aračinovo",
      "Berovo",
      "Bitola",
      "Bogdanci",
      "Bogovinje",
      "Bosilovo",
      "Brvenica",
      "Butel",
      "Čair",
      "Čaška",
      "Centar",
      "Centar Župa",
      "Češinovo-Obleševo",
      "Čučer-Sandevo",
      "Debarca",
      "Delčevo",
      "Demir Hisar",
      "Demir Kapija",
      "Dojran",
      "Dolneni",
      "Drugovo",
      "Gazi Baba",
      "Gevgelija",
      "Gjorče Petrov",
      "Gostivar",
      "Gradsko",
      "Greater Skopje",
      "Ilinden",
      "Jegunovce",
      "Karbinci",
      "Karpoš",
      "Kavadarci",
      "Kičevo",
      "Kisela Voda",
      "Kočani",
      "Konče",
      "Kratovo",
      "Kriva Palanka",
      "Krivogaštani",
      "Kruševo",
      "Kumanovo",
      "Lipkovo",
      "Lozovo",
      "Makedonska Kamenica",
      "Makedonski Brod",
      "Mavrovo and Rostuša",
      "Mogila",
      "Negotino",
      "Novaci",
      "Novo Selo",
      "Ohrid",
      "Oslomej ",
      "Pehčevo",
      "Petrovec",
      "Plasnica",
      "Prilep",
      "Probištip",
      "Radoviš",
      "Rankovce",
      "Resen",
      "Rosoman",
      "Saraj",
      "Sopište",
      "Staro Nagoričane",
      "Štip",
      "Struga",
      "Strumica",
      "Studeničani",
      "Šuto Orizari",
      "Sveti Nikole",
      "Tearce",
      "Tetovo",
      "Valandovo",
      "Vasilevo",
      "Veles",
      "Vevčani",
      "Vinica",
      "Vraneštica",
      "Vrapčište",
      "Zajas",
      "Zelenikovo",
      "Želino",
      "Zrnovci"
    ]
  },
  {
    "name": "Northern Mariana Islands",
    "states": []
  },
  {
    "name": "Norway",
    "states": [
      "Agder",
      "Akershus",
      "Buskerud",
      "Finnmark",
      "Innlandet",
      "Jan Mayen",
      "Møre og Romsdal",
      "Nordland",
      "Oslo",
      "Østfold",
      "Rogaland",
      "Svalbard",
      "Telemark",
      "Troms",
      "Trøndelag",
      "Vestfold",
      "Vestland"
    ]
  },
  {
    "name": "Oman",
    "states": [
      "Ad Dakhiliyah",
      "Ad Dhahirah",
      "Al Batinah North",
      "Al Batinah Region",
      "Al Batinah South",
      "Al Buraimi",
      "Al Wusta",
      "Ash Sharqiyah North",
      "Ash Sharqiyah Region",
      "Ash Sharqiyah South",
      "Dhofar",
      "Musandam",
      "Muscat"
    ]
  },
  {
    "name": "Pakistan",
    "states": [
      "Azad Kashmir",
      "Balochistan",
      "Federally Administered Tribal Areas",
      "Gilgit-Baltistan",
      "Islamabad",
      "Khyber Pakhtunkhwa",
      "Punjab",
      "Sindh"
    ]
  },
  {
    "name": "Palau",
    "states": [
      "Aimeliik",
      "Airai",
      "Angaur",
      "Hatohobei",
      "Kayangel",
      "Koror",
      "Melekeok",
      "Ngaraard",
      "Ngarchelong",
      "Ngardmau",
      "Ngatpang",
      "Ngchesar",
      "Ngeremlengui",
      "Ngiwal",
      "Peleliu",
      "Sonsorol"
    ]
  },
  {
    "name": "Palestinian Territory Occupied",
    "states": [
      "Bethlehem",
      "Deir El Balah",
      "Gaza",
      "Hebron",
      "Jenin",
      "Jericho ",
      "Jerusalem (Quds)",
      "Khan Yunis",
      "Nablus",
      "North Gaza",
      "Qalqilya",
      "Rafah",
      "Ramallah",
      "Salfit",
      "Tubas",
      "Tulkarm"
    ]
  },
  {
    "name": "Panama",
    "states": [
      "Bocas del Toro",
      "Chiriquí Province",
      "Coclé",
      "Colón",
      "Darién",
      "Emberá-Wounaan Comarca",
      "Guna",
      "Herrera",
      "Los Santos",
      "Ngöbe-Buglé Comarca",
      "Panamá",
      "Panamá Oeste",
      "Veraguas"
    ]
  },
  {
    "name": "Papua New Guinea",
    "states": [
      "Bougainville",
      "Central",
      "Chimbu",
      "East New Britain",
      "East Sepik",
      "Eastern Highlands",
      "Enga",
      "Gulf",
      "Hela",
      "Jiwaka",
      "Madang",
      "Manus",
      "Milne Bay",
      "Morobe",
      "New Ireland",
      "Oro",
      "Port Moresby",
      "Sandaun",
      "Southern Highlands",
      "West New Britain",
      "Western",
      "Western Highlands"
    ]
  },
  {
    "name": "Paraguay",
    "states": [
      "Alto Paraguay",
      "Alto Paraná",
      "Amambay",
      "Asuncion",
      "Boquerón",
      "Caaguazú",
      "Caazapá",
      "Canindeyú",
      "Central",
      "Concepción",
      "Cordillera",
      "Guairá",
      "Itapúa",
      "Misiones",
      "Ñeembucú",
      "Paraguarí",
      "Presidente Hayes",
      "San Pedro"
    ]
  },
  {
    "name": "Peru",
    "states": [
      "Amazonas",
      "Áncash",
      "Apurímac",
      "Arequipa",
      "Ayacucho",
      "Cajamarca",
      "Callao",
      "Cusco",
      "Huancavelica",
      "Huanuco",
      "Ica",
      "Junín",
      "La Libertad",
      "Lambayeque",
      "Lima",
      "Loreto",
      "Madre de Dios",
      "Moquegua",
      "Pasco",
      "Piura",
      "Puno",
      "San Martín",
      "Tacna",
      "Tumbes",
      "Ucayali"
    ]
  },
  {
    "name": "Philippines",
    "states": [
      "Abra",
      "Agusan del Norte",
      "Agusan del Sur",
      "Aklan",
      "Albay",
      "Antique",
      "Apayao",
      "Aurora",
      "Autonomous Region in Muslim Mindanao",
      "Basilan",
      "Bataan",
      "Batanes",
      "Batangas",
      "Benguet",
      "Bicol",
      "Biliran",
      "Bohol",
      "Bukidnon",
      "Bulacan",
      "Cagayan",
      "Cagayan Valley",
      "Calabarzon",
      "Camarines Norte",
      "Camarines Sur",
      "Camiguin",
      "Capiz",
      "Caraga",
      "Catanduanes",
      "Cavite",
      "Cebu",
      "Central Luzon",
      "Central Visayas",
      "Cordillera Administrative",
      "Cotabato",
      "Davao",
      "Davao de Oro",
      "Davao del Norte",
      "Davao del Sur",
      "Davao Occidental",
      "Davao Oriental",
      "Dinagat Islands",
      "Eastern Samar",
      "Eastern Visayas",
      "Guimaras",
      "Ifugao",
      "Ilocos",
      "Ilocos Norte",
      "Ilocos Sur",
      "Iloilo",
      "Isabela",
      "Kalinga",
      "La Union",
      "Laguna",
      "Lanao del Norte",
      "Lanao del Sur",
      "Leyte",
      "Maguindanao del Norte",
      "Maguindanao del Sur",
      "Marinduque",
      "Masbate",
      "Mimaropa",
      "Misamis Occidental",
      "Misamis Oriental",
      "Mountain Province",
      "National Capital Region (Metro Manila)",
      "Negros Occidental",
      "Negros Oriental",
      "Northern Mindanao",
      "Northern Samar",
      "Nueva Ecija",
      "Nueva Vizcaya",
      "Occidental Mindoro",
      "Oriental Mindoro",
      "Palawan",
      "Pampanga",
      "Pangasinan",
      "Quezon",
      "Quirino",
      "Rizal",
      "Romblon",
      "Sarangani",
      "Siquijor",
      "Soccsksargen",
      "Sorsogon",
      "South Cotabato",
      "Southern Leyte",
      "Sultan Kudarat",
      "Sulu",
      "Surigao del Norte",
      "Surigao del Sur",
      "Tarlac",
      "Tawi-Tawi",
      "Western Samar",
      "Western Visayas",
      "Zambales",
      "Zamboanga del Norte",
      "Zamboanga del Sur",
      "Zamboanga Peninsula",
      "Zamboanga Sibugay"
    ]
  },
  {
    "name": "Pitcairn Island",
    "states": []
  },
  {
    "name": "Poland",
    "states": [
      "Greater Poland",
      "Holy Cross",
      "Kuyavia-Pomerania",
      "Lesser Poland",
      "Lower Silesia",
      "Lublin",
      "Lubusz",
      "Łódź",
      "Mazovia",
      "Podlaskie",
      "Pomerania",
      "Silesia",
      "Subcarpathia",
      "Upper Silesia",
      "Warmia-Masuria",
      "West Pomerania"
    ]
  },
  {
    "name": "Portugal",
    "states": [
      "Açores",
      "Aveiro",
      "Beja",
      "Braga",
      "Bragança",
      "Castelo Branco",
      "Coimbra",
      "Évora",
      "Faro",
      "Guarda",
      "Leiria",
      "Lisbon",
      "Madeira",
      "Portalegre",
      "Porto",
      "Santarém",
      "Setúbal",
      "Viana do Castelo",
      "Vila Real",
      "Viseu"
    ]
  },
  {
    "name": "Puerto Rico",
    "states": [
      "Adjuntas",
      "Aguada",
      "Aguadilla",
      "Aguas Buenas",
      "Aibonito",
      "Añasco",
      "Arecibo",
      "Arecibo",
      "Arroyo",
      "Barceloneta",
      "Barranquitas",
      "Bayamon",
      "Bayamón",
      "Cabo Rojo",
      "Caguas",
      "Caguas",
      "Camuy",
      "Canóvanas",
      "Carolina",
      "Carolina",
      "Cataño",
      "Cayey",
      "Ceiba",
      "Ciales",
      "Cidra",
      "Coamo",
      "Comerío",
      "Corozal",
      "Culebra",
      "Dorado",
      "Fajardo",
      "Florida",
      "Guánica",
      "Guayama",
      "Guayanilla",
      "Guaynabo",
      "Guaynabo",
      "Gurabo",
      "Hatillo",
      "Hormigueros",
      "Humacao",
      "Isabela",
      "Jayuya",
      "Juana Díaz",
      "Juncos",
      "Lajas",
      "Lares",
      "Las Marías",
      "Las Piedras",
      "Loíza",
      "Luquillo",
      "Manatí",
      "Maricao",
      "Maunabo",
      "Mayagüez",
      "Mayagüez",
      "Moca",
      "Morovis",
      "Naguabo",
      "Naranjito",
      "Orocovis",
      "Patillas",
      "Peñuelas",
      "Ponce",
      "Ponce",
      "Quebradillas",
      "Rincón",
      "Río Grande",
      "Sabana Grande",
      "Salinas",
      "San Germán",
      "San Juan",
      "San Juan",
      "San Lorenzo",
      "San Sebastián",
      "Santa Isabel",
      "Toa Alta",
      "Toa Baja",
      "Toa Baja",
      "Trujillo Alto",
      "Trujillo Alto",
      "Utuado",
      "Vega Alta",
      "Vega Baja",
      "Vieques",
      "Villalba",
      "Yabucoa",
      "Yauco"
    ]
  },
  {
    "name": "Qatar",
    "states": [
      "Al Daayen",
      "Al Khor",
      "Al Rayyan",
      "Al Wakrah",
      "Al-Shahaniya",
      "Doha",
      "Madinat ash Shamal",
      "Umm Salal"
    ]
  },
  {
    "name": "Reunion",
    "states": [
      "Saint-Benoît",
      "Saint-Denis",
      "Saint-Paul",
      "Saint-Pierre"
    ]
  },
  {
    "name": "Romania",
    "states": [
      "Alba",
      "Arad",
      "Arges",
      "Bacău",
      "Bihor",
      "Bistrița-Năsăud",
      "Botoșani",
      "Braila",
      "Brașov",
      "Bucharest",
      "Buzău",
      "Călărași",
      "Caraș-Severin",
      "Cluj",
      "Constanța",
      "Covasna",
      "Dâmbovița",
      "Dolj",
      "Galați",
      "Giurgiu",
      "Gorj",
      "Harghita",
      "Hunedoara",
      "Ialomița",
      "Iași",
      "Ilfov",
      "Maramureș",
      "Mehedinți",
      "Mureș",
      "Neamț",
      "Olt",
      "Prahova",
      "Sălaj",
      "Satu Mare",
      "Sibiu",
      "Suceava",
      "Teleorman",
      "Timiș",
      "Tulcea",
      "Vâlcea",
      "Vaslui",
      "Vrancea"
    ]
  },
  {
    "name": "Russia",
    "states": [
      "Adygea",
      "Altai",
      "Altai",
      "Amur",
      "Arkhangelsk",
      "Astrakhan",
      "Bashkortostan",
      "Belgorod",
      "Bryansk",
      "Buryatia",
      "Chechen",
      "Chelyabinsk",
      "Chukotka",
      "Chuvash",
      "Dagestan",
      "Ingushetia",
      "Irkutsk",
      "Ivanovo",
      "Jewish",
      "Kabardino-Balkar",
      "Kaliningrad",
      "Kalmykia",
      "Kaluga",
      "Kamchatka",
      "Karachay-Cherkess",
      "Karelia",
      "Kemerovo",
      "Khabarovsk",
      "Khakassia",
      "Khanty-Mansi",
      "Kirov",
      "Komi",
      "Kostroma",
      "Krasnodar",
      "Krasnoyarsk",
      "Kurgan",
      "Kursk",
      "Leningrad",
      "Lipetsk",
      "Magadan",
      "Mari El",
      "Mordovia",
      "Moscow",
      "Moscow",
      "Murmansk",
      "Nenets",
      "Nizhny Novgorod",
      "North Ossetia-Alania",
      "Novgorod",
      "Novosibirsk",
      "Omsk",
      "Orenburg",
      "Oryol",
      "Penza",
      "Perm",
      "Primorsky",
      "Pskov",
      "Rostov",
      "Ryazan",
      "Saint Petersburg",
      "Sakha",
      "Sakhalin",
      "Samara",
      "Saratov",
      "Smolensk",
      "Stavropol",
      "Sverdlovsk",
      "Tambov",
      "Tatarstan",
      "Tomsk",
      "Tula",
      "Tuva",
      "Tver",
      "Tyumen",
      "Udmurt",
      "Ulyanovsk",
      "Vladimir",
      "Volgograd Oblast",
      "Vologda",
      "Voronezh",
      "Yamalo-Nenets",
      "Yaroslavl",
      "Zabaykalsky"
    ]
  },
  {
    "name": "Rwanda",
    "states": [
      "Eastern",
      "Kigali",
      "Northern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Saint Helena",
    "states": [
      "Alarm Forest",
      "Blue Hill",
      "Half Tree Hollow",
      "Jamestown",
      "Levelwood",
      "Longwood",
      "Saint Paul's",
      "Sandy Bay"
    ]
  },
  {
    "name": "Saint Kitts and Nevis",
    "states": [
      "Christ Church Nichola Town",
      "Nevis",
      "Saint Anne Sandy Point",
      "Saint George Basseterre",
      "Saint George Gingerland",
      "Saint James Windward",
      "Saint John Capisterre",
      "Saint John Figtree",
      "Saint Kitts",
      "Saint Mary Cayon",
      "Saint Paul Capisterre",
      "Saint Paul Charlestown",
      "Saint Peter Basseterre",
      "Saint Thomas Lowland",
      "Saint Thomas Middle Island",
      "Trinity Palmetto Point"
    ]
  },
  {
    "name": "Saint Lucia",
    "states": [
      "Anse la Raye",
      "Canaries",
      "Castries",
      "Choiseul",
      "Dauphin",
      "Dennery",
      "Gros Islet",
      "Laborie",
      "Micoud",
      "Praslin",
      "Soufrière",
      "Vieux Fort"
    ]
  },
  {
    "name": "Saint Pierre and Miquelon",
    "states": []
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "states": [
      "Charlotte",
      "Grenadines",
      "Saint Andrew",
      "Saint David",
      "Saint George",
      "Saint Patrick"
    ]
  },
  {
    "name": "Saint-Barthelemy",
    "states": []
  },
  {
    "name": "Saint-Martin (French part)",
    "states": []
  },
  {
    "name": "Samoa",
    "states": [
      "A'ana",
      "Aiga-i-le-Tai",
      "Atua",
      "Fa'asaleleaga",
      "Gaga'emauga",
      "Gaga'ifomauga",
      "Palauli",
      "Satupa'itea",
      "Tuamasaga",
      "Va'a-o-Fonoti",
      "Vaisigano"
    ]
  },
  {
    "name": "San Marino",
    "states": [
      "Acquaviva",
      "Borgo Maggiore",
      "Chiesanuova",
      "Domagnano",
      "Faetano",
      "Fiorentino",
      "Montegiardino",
      "San Marino",
      "Serravalle"
    ]
  },
  {
    "name": "Sao Tome and Principe",
    "states": [
      "Príncipe",
      "São Tomé"
    ]
  },
  {
    "name": "Saudi Arabia",
    "states": [
      "'Asir",
      "Al Bahah",
      "Al Jawf",
      "Al Madinah",
      "Al-Qassim",
      "Eastern Province",
      "Ha'il",
      "Jizan",
      "Makkah",
      "Najran",
      "Northern Borders",
      "Riyadh",
      "Tabuk"
    ]
  },
  {
    "name": "Senegal",
    "states": [
      "Dakar",
      "Diourbel Region",
      "Fatick",
      "Kaffrine",
      "Kaolack",
      "Kédougou",
      "Kolda",
      "Louga",
      "Matam",
      "Saint-Louis",
      "Sédhiou",
      "Tambacounda Region",
      "Thiès Region",
      "Ziguinchor"
    ]
  },
  {
    "name": "Serbia",
    "states": [
      "Belgrade",
      "Bor",
      "Braničevo",
      "Central Banat",
      "Jablanica",
      "Kolubara",
      "Mačva",
      "Moravica",
      "Nišava",
      "North Bačka",
      "North Banat",
      "Pčinja",
      "Pirot",
      "Podunavlje",
      "Pomoravlje",
      "Rasina",
      "Raška",
      "South Bačka",
      "South Banat",
      "Srem",
      "Šumadija",
      "Toplica",
      "Vojvodina",
      "West Bačka",
      "Zaječar",
      "Zlatibor"
    ]
  },
  {
    "name": "Seychelles",
    "states": [
      "Anse Boileau",
      "Anse Royale",
      "Anse-aux-Pins",
      "Au Cap",
      "Baie Lazare",
      "Baie Sainte Anne",
      "Beau Vallon",
      "Bel Air",
      "Bel Ombre",
      "Cascade",
      "Glacis",
      "Grand'Anse Mahé",
      "Grand'Anse Praslin",
      "La Digue",
      "La Rivière Anglaise",
      "Les Mamelles",
      "Mont Buxton",
      "Mont Fleuri",
      "Plaisance",
      "Pointe La Rue",
      "Port Glaud",
      "Roche Caiman",
      "Saint Louis",
      "Takamaka"
    ]
  },
  {
    "name": "Sierra Leone",
    "states": [
      "Eastern",
      "Northern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Singapore",
    "states": [
      "Central Singapore",
      "North East",
      "North West",
      "South East",
      "South West"
    ]
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "states": []
  },
  {
    "name": "Slovakia",
    "states": [
      "Banská Bystrica",
      "Bratislava",
      "Košice",
      "Nitra",
      "Prešov",
      "Trenčín",
      "Trnava",
      "Žilina"
    ]
  },
  {
    "name": "Slovenia",
    "states": [
      "Ajdovščina",
      "Ankaran",
      "Apače",
      "Beltinci",
      "Benedikt",
      "Bistrica ob Sotli",
      "Bled",
      "Bloke",
      "Bohinj",
      "Borovnica",
      "Bovec",
      "Braslovče",
      "Brda",
      "Brežice",
      "Brezovica",
      "Cankova",
      "Celje",
      "Cerklje na Gorenjskem",
      "Cerknica",
      "Cerkno",
      "Cerkvenjak",
      "Cirkulane",
      "Črenšovci",
      "Črna na Koroškem",
      "Črnomelj",
      "Destrnik",
      "Divača",
      "Dobje",
      "Dobrepolje",
      "Dobrna",
      "Dobrova–Polhov Gradec",
      "Dobrovnik",
      "Dol pri Ljubljani",
      "Dolenjske Toplice",
      "Domžale",
      "Dornava",
      "Dravograd",
      "Duplek",
      "Gorenja Vas–Poljane",
      "Gorišnica",
      "Gorje",
      "Gornja Radgona",
      "Gornji Grad",
      "Gornji Petrovci",
      "Grad",
      "Grosuplje",
      "Hajdina",
      "Hoče–Slivnica",
      "Hodoš",
      "Horjul",
      "Hrastnik",
      "Hrpelje–Kozina",
      "Idrija",
      "Ig",
      "Ilirska Bistrica",
      "Ivančna Gorica",
      "Izola",
      "Jesenice",
      "Jezersko",
      "Juršinci",
      "Kamnik",
      "Kanal ob Soči",
      "Kidričevo",
      "Kobarid",
      "Kobilje",
      "Kočevje",
      "Komen",
      "Komenda",
      "Koper",
      "Kostanjevica na Krki",
      "Kostel",
      "Kozje",
      "Kranj",
      "Kranjska Gora",
      "Križevci",
      "Krško",
      "Kungota",
      "Kuzma",
      "Laško",
      "Lenart",
      "Lendava",
      "Litija",
      "Ljubljana",
      "Ljubno",
      "Ljutomer",
      "Log–Dragomer",
      "Logatec",
      "Loška Dolina",
      "Loški Potok",
      "Lovrenc na Pohorju",
      "Luče",
      "Lukovica",
      "Majšperk",
      "Makole",
      "Maribor",
      "Markovci",
      "Medvode",
      "Mengeš",
      "Metlika",
      "Mežica",
      "Miklavž na Dravskem Polju",
      "Miren–Kostanjevica",
      "Mirna",
      "Mirna Peč",
      "Mislinja",
      "Mokronog–Trebelno",
      "Moravče",
      "Moravske Toplice",
      "Mozirje",
      "Murska Sobota",
      "Muta",
      "Naklo",
      "Nazarje",
      "Nova Gorica",
      "Novo Mesto",
      "Odranci",
      "Oplotnica",
      "Ormož",
      "Osilnica",
      "Pesnica",
      "Piran",
      "Pivka",
      "Podčetrtek",
      "Podlehnik",
      "Podvelka",
      "Poljčane",
      "Polzela",
      "Postojna",
      "Prebold",
      "Preddvor",
      "Prevalje",
      "Ptuj",
      "Puconci",
      "Rače–Fram",
      "Radeče",
      "Radenci",
      "Radlje ob Dravi",
      "Radovljica",
      "Ravne na Koroškem",
      "Razkrižje",
      "Rečica ob Savinji",
      "Renče–Vogrsko",
      "Ribnica",
      "Ribnica na Pohorju",
      "Rogaška Slatina",
      "Rogašovci",
      "Rogatec",
      "Ruše",
      "Šalovci",
      "Selnica ob Dravi",
      "Semič",
      "Šempeter–Vrtojba",
      "Šenčur",
      "Šentilj",
      "Šentjernej",
      "Šentjur",
      "Šentrupert",
      "Sevnica",
      "Sežana",
      "Škocjan",
      "Škofja Loka",
      "Škofljica",
      "Slovenj Gradec",
      "Slovenska Bistrica",
      "Slovenske Konjice",
      "Šmarje pri Jelšah",
      "Šmarješke Toplice",
      "Šmartno ob Paki",
      "Šmartno pri Litiji",
      "Sodražica",
      "Solčava",
      "Šoštanj",
      "Središče ob Dravi",
      "Starše",
      "Štore",
      "Straža",
      "Sveta Ana",
      "Sveta Trojica v Slovenskih Goricah",
      "Sveti Andraž v Slovenskih Goricah",
      "Sveti Jurij ob Ščavnici",
      "Sveti Jurij v Slovenskih Goricah",
      "Sveti Tomaž",
      "Tabor",
      "Tišina",
      "Tolmin",
      "Trbovlje",
      "Trebnje",
      "Trnovska Vas",
      "Tržič",
      "Trzin",
      "Turnišče",
      "Velika Polana",
      "Velike Lašče",
      "Veržej",
      "Videm",
      "Vipava",
      "Vitanje",
      "Vodice",
      "Vojnik",
      "Vransko",
      "Vrhnika",
      "Vuzenica",
      "Zagorje ob Savi",
      "Žalec",
      "Zavrč",
      "Železniki",
      "Žetale",
      "Žiri",
      "Žirovnica",
      "Zreče",
      "Žužemberk"
    ]
  },
  {
    "name": "Solomon Islands",
    "states": [
      "Central",
      "Choiseul",
      "Guadalcanal",
      "Honiara",
      "Isabel",
      "Makira-Ulawa",
      "Malaita",
      "Rennell and Bellona",
      "Temotu",
      "Western"
    ]
  },
  {
    "name": "Somalia",
    "states": [
      "Awdal",
      "Bakool",
      "Banaadir",
      "Bari",
      "Bay",
      "Galguduud",
      "Gedo",
      "Hiran",
      "Lower Juba",
      "Lower Shebelle",
      "Middle Juba",
      "Middle Shebelle",
      "Mudug",
      "Nugal",
      "Sanaag",
      "Togdheer"
    ]
  },
  {
    "name": "South Africa",
    "states": [
      "Eastern Cape",
      "Free State",
      "Gauteng",
      "KwaZulu-Natal",
      "Limpopo",
      "Mpumalanga",
      "North West",
      "Northern Cape",
      "Western Cape"
    ]
  },
  {
    "name": "South Georgia",
    "states": []
  },
  {
    "name": "South Korea",
    "states": [
      "Busan",
      "Daegu",
      "Daejeon",
      "Gangwon",
      "Gwangju",
      "Gyeonggi",
      "Incheon",
      "Jeju",
      "North Chungcheong",
      "North Gyeongsang",
      "North Jeolla",
      "Sejong City",
      "Seoul",
      "South Chungcheong",
      "South Gyeongsang",
      "South Jeolla",
      "Ulsan"
    ]
  },
  {
    "name": "South Sudan",
    "states": [
      "Central Equatoria",
      "Eastern Equatoria",
      "Jonglei State",
      "Lakes",
      "Northern Bahr el Ghazal",
      "Unity",
      "Upper Nile",
      "Warrap",
      "Western Bahr el Ghazal",
      "Western Equatoria"
    ]
  },
  {
    "name": "Spain",
    "states": [
      "A Coruña",
      "Albacete",
      "Alicante",
      "Almeria",
      "Andalusia",
      "Araba",
      "Aragon",
      "Asturias",
      "Asturias",
      "Ávila",
      "Badajoz",
      "Balearic Islands",
      "Barcelona",
      "Basque Country",
      "Bizkaia",
      "Burgos",
      "Caceres",
      "Cádiz",
      "Canary Islands",
      "Cantabria",
      "Cantabria",
      "Castellón",
      "Castile and Leon",
      "Castilla-La Mancha",
      "Catalonia",
      "Ceuta",
      "Ciudad Real",
      "Community of Madrid",
      "Córdoba",
      "Cuenca",
      "Estremadura",
      "Galicia",
      "Gipuzkoa",
      "Girona",
      "Granada",
      "Guadalajara",
      "Huelva",
      "Huesca",
      "Islas Baleares",
      "Jaén",
      "La Rioja",
      "La Rioja",
      "Las Palmas",
      "León",
      "Lleida",
      "Lugo",
      "Madrid",
      "Málaga",
      "Melilla",
      "Murcia",
      "Navarra",
      "Navarre",
      "Ourense",
      "Palencia",
      "Pontevedra",
      "Region of Murcia",
      "Salamanca",
      "Santa Cruz de Tenerife",
      "Segovia",
      "Sevilla",
      "Soria",
      "Tarragona",
      "Teruel",
      "Toledo",
      "Valencia",
      "Valencian Community",
      "Valladolid",
      "Zamora",
      "Zaragoza"
    ]
  },
  {
    "name": "Sri Lanka",
    "states": [
      "Ampara",
      "Anuradhapura",
      "Badulla",
      "Batticaloa",
      "Central",
      "Colombo",
      "Eastern",
      "Galle",
      "Gampaha",
      "Hambantota",
      "Jaffna",
      "Kalutara",
      "Kandy",
      "Kegalle",
      "Kilinochchi",
      "Kurunegala",
      "Mannar",
      "Matale",
      "Matara",
      "Monaragala",
      "Mullaitivu",
      "North Central",
      "North Western",
      "Northern",
      "Nuwara Eliya",
      "Polonnaruwa",
      "Puttalam",
      "Ratnapura",
      "Sabaragamuwa",
      "Southern",
      "Trincomalee",
      "Uva",
      "Vavuniya",
      "Western"
    ]
  },
  {
    "name": "Sudan",
    "states": [
      "Al Jazirah",
      "Al Qadarif",
      "Blue Nile",
      "Central Darfur",
      "East Darfur",
      "Kassala",
      "Khartoum",
      "North Darfur",
      "North Kordofan",
      "Northern",
      "Red Sea",
      "River Nile",
      "Sennar",
      "South Darfur",
      "South Kordofan",
      "West Darfur",
      "West Kordofan",
      "White Nile"
    ]
  },
  {
    "name": "Suriname",
    "states": [
      "Brokopondo",
      "Commewijne",
      "Coronie",
      "Marowijne",
      "Nickerie",
      "Para",
      "Paramaribo",
      "Saramacca",
      "Sipaliwini",
      "Wanica"
    ]
  },
  {
    "name": "Svalbard and Jan Mayen Islands",
    "states": []
  },
  {
    "name": "Sweden",
    "states": [
      "Blekinge",
      "Dalarna",
      "Gävleborg",
      "Gotland",
      "Halland",
      "Jämtland",
      "Jönköping",
      "Kalmar",
      "Kronoberg",
      "Norrbotten",
      "Örebro",
      "Östergötland",
      "Skåne",
      "Södermanland",
      "Stockholm",
      "Uppsala",
      "Värmland",
      "Västerbotten",
      "Västernorrland",
      "Västmanland",
      "Västra Götaland"
    ]
  },
  {
    "name": "Switzerland",
    "states": [
      "Aargau",
      "Appenzell Ausserrhoden",
      "Appenzell Innerrhoden",
      "Basel-Land",
      "Basel-Stadt",
      "Bern",
      "Fribourg",
      "Geneva",
      "Glarus",
      "Graubünden",
      "Jura",
      "Lucerne",
      "Neuchâtel",
      "Nidwalden",
      "Obwalden",
      "Schaffhausen",
      "Schwyz",
      "Solothurn",
      "St. Gallen",
      "Thurgau",
      "Ticino",
      "Uri",
      "Valais",
      "Vaud",
      "Zug",
      "Zürich"
    ]
  },
  {
    "name": "Syria",
    "states": [
      "Al-Hasakah",
      "Al-Raqqah",
      "Aleppo",
      "As-Suwayda",
      "Damascus",
      "Daraa",
      "Deir ez-Zor",
      "Hama",
      "Homs",
      "Idlib",
      "Latakia",
      "Quneitra",
      "Rif Dimashq",
      "Tartus"
    ]
  },
  {
    "name": "Taiwan",
    "states": [
      "Changhua",
      "Chiayi",
      "Chiayi",
      "Hsinchu",
      "Hsinchu",
      "Hualien",
      "Kaohsiung",
      "Keelung",
      "Kinmen",
      "Lienchiang",
      "Miaoli",
      "Nantou",
      "New Taipei",
      "Penghu",
      "Pingtung",
      "Taichung",
      "Tainan",
      "Taipei",
      "Taitung",
      "Taoyuan",
      "Yilan",
      "Yunlin"
    ]
  },
  {
    "name": "Tajikistan",
    "states": [
      "Gorno-Badakhshan",
      "Khatlon",
      "Nohiyahoi Tobei Jumhurí ",
      "Sughd "
    ]
  },
  {
    "name": "Tanzania",
    "states": [
      "Arusha",
      "Dar es Salaam",
      "Dodoma",
      "Geita",
      "Iringa",
      "Kagera",
      "Katavi",
      "Kigoma",
      "Kilimanjaro",
      "Lindi",
      "Manyara",
      "Mara",
      "Mbeya",
      "Morogoro",
      "Mtwara",
      "Mwanza",
      "Njombe",
      "Pemba North",
      "Pemba South",
      "Pwani",
      "Rukwa",
      "Ruvuma",
      "Shinyanga",
      "Simiyu",
      "Singida",
      "Songwe",
      "Tabora",
      "Tanga",
      "Zanzibar North",
      "Zanzibar South",
      "Zanzibar West"
    ]
  },
  {
    "name": "Thailand",
    "states": [
      "Amnat Charoen",
      "Ang Thong",
      "Bangkok",
      "Bueng Kan",
      "Buri Ram",
      "Chachoengsao",
      "Chai Nat",
      "Chaiyaphum",
      "Chanthaburi",
      "Chiang Mai",
      "Chiang Rai",
      "Chon Buri",
      "Chumphon",
      "Kalasin",
      "Kamphaeng Phet",
      "Kanchanaburi",
      "Khon Kaen",
      "Krabi",
      "Lampang",
      "Lamphun",
      "Loei",
      "Lop Buri",
      "Mae Hong Son",
      "Maha Sarakham",
      "Mukdahan",
      "Nakhon Nayok",
      "Nakhon Pathom",
      "Nakhon Phanom",
      "Nakhon Ratchasima",
      "Nakhon Sawan",
      "Nakhon Si Thammarat",
      "Nan",
      "Narathiwat",
      "Nong Bua Lam Phu",
      "Nong Khai",
      "Nonthaburi",
      "Pathum Thani",
      "Pattani",
      "Pattaya",
      "Phangnga",
      "Phatthalung",
      "Phayao",
      "Phetchabun",
      "Phetchaburi",
      "Phichit",
      "Phitsanulok",
      "Phra Nakhon Si Ayutthaya",
      "Phrae",
      "Phuket",
      "Prachin Buri",
      "Prachuap Khiri Khan",
      "Ranong",
      "Ratchaburi",
      "Rayong",
      "Roi Et",
      "Sa Kaeo",
      "Sakon Nakhon",
      "Samut Prakan",
      "Samut Sakhon",
      "Samut Songkhram",
      "Saraburi",
      "Satun",
      "Si Sa Ket",
      "Sing Buri",
      "Songkhla",
      "Sukhothai",
      "Suphan Buri",
      "Surat Thani",
      "Surin",
      "Tak",
      "Trang",
      "Trat",
      "Ubon Ratchathani",
      "Udon Thani",
      "Uthai Thani",
      "Uttaradit",
      "Yala",
      "Yasothon"
    ]
  },
  {
    "name": "The Bahamas",
    "states": [
      "Acklins",
      "Acklins and Crooked Islands",
      "Berry Islands",
      "Bimini",
      "Black Point",
      "Cat Island",
      "Central Abaco",
      "Central Andros",
      "Central Eleuthera",
      "Crooked Island",
      "East Grand Bahama",
      "Exuma",
      "Freeport",
      "Fresh Creek",
      "Governor's Harbour",
      "Grand Cay",
      "Green Turtle Cay",
      "Harbour Island",
      "High Rock",
      "Hope Town",
      "Inagua",
      "Kemps Bay",
      "Long Island",
      "Mangrove Cay",
      "Marsh Harbour",
      "Mayaguana",
      "New Providence",
      "Nichollstown and Berry Islands",
      "North Abaco",
      "North Andros",
      "North Eleuthera",
      "Ragged Island",
      "Rock Sound",
      "Rum Cay",
      "San Salvador and Rum Cay",
      "San Salvador Island",
      "Sandy Point",
      "South Abaco",
      "South Andros",
      "South Eleuthera",
      "Spanish Wells",
      "West Grand Bahama"
    ]
  },
  {
    "name": "The Gambia ",
    "states": [
      "Banjul",
      "Central River",
      "Lower River",
      "North Bank",
      "Upper River",
      "West Coast"
    ]
  },
  {
    "name": "Timor-Leste",
    "states": [
      "Aileu",
      "Ainaro",
      "Baucau",
      "Bobonaro",
      "Cova Lima",
      "Dili",
      "Ermera",
      "Lautém",
      "Liquiçá",
      "Manatuto",
      "Manufahi",
      "Viqueque"
    ]
  },
  {
    "name": "Togo",
    "states": [
      "Centrale",
      "Kara",
      "Maritime",
      "Plateaux",
      "Savanes"
    ]
  },
  {
    "name": "Tokelau",
    "states": []
  },
  {
    "name": "Tonga",
    "states": [
      "Haʻapai",
      "ʻEua",
      "Niuas",
      "Tongatapu",
      "Vavaʻu"
    ]
  },
  {
    "name": "Trinidad and Tobago",
    "states": [
      "Arima",
      "Chaguanas",
      "Couva-Tabaquite-Talparo",
      "Diego Martin",
      "Eastern Tobago",
      "Penal-Debe",
      "Point Fortin",
      "Port of Spain",
      "Princes Town",
      "Rio Claro-Mayaro",
      "San Fernando",
      "San Juan-Laventille",
      "Sangre Grande",
      "Siparia",
      "Tunapuna-Piarco",
      "Western Tobago"
    ]
  },
  {
    "name": "Tunisia",
    "states": [
      "Ariana",
      "Béja",
      "Ben Arous",
      "Bizerte",
      "Gabès",
      "Gafsa",
      "Jendouba",
      "Kairouan",
      "Kasserine",
      "Kebili",
      "Kef",
      "Mahdia",
      "Manouba",
      "Medenine",
      "Monastir",
      "Nabeul",
      "Sfax",
      "Sidi Bouzid",
      "Siliana",
      "Sousse",
      "Tataouine",
      "Tozeur",
      "Tunis",
      "Zaghouan"
    ]
  },
  {
    "name": "Turkey",
    "states": [
      "Adana",
      "Adıyaman",
      "Afyonkarahisar",
      "Ağrı",
      "Aksaray",
      "Amasya",
      "Ankara",
      "Antalya",
      "Ardahan",
      "Artvin",
      "Aydın",
      "Balıkesir",
      "Bartın",
      "Batman",
      "Bayburt",
      "Bilecik",
      "Bingöl",
      "Bitlis",
      "Bolu",
      "Burdur",
      "Bursa",
      "Çanakkale",
      "Çankırı",
      "Çorum",
      "Denizli",
      "Diyarbakır",
      "Düzce",
      "Edirne",
      "Elazığ",
      "Erzincan",
      "Erzurum",
      "Eskişehir",
      "Gaziantep",
      "Giresun",
      "Gümüşhane",
      "Hakkâri",
      "Hatay",
      "Iğdır",
      "Isparta",
      "İstanbul",
      "İzmir",
      "Kahramanmaraş",
      "Karabük",
      "Karaman",
      "Kars",
      "Kastamonu",
      "Kayseri",
      "Kilis",
      "Kırıkkale",
      "Kırklareli",
      "Kırşehir",
      "Kocaeli",
      "Konya",
      "Kütahya",
      "Malatya",
      "Manisa",
      "Mardin",
      "Mersin",
      "Muğla",
      "Muş",
      "Nevşehir",
      "Niğde",
      "Ordu",
      "Osmaniye",
      "Rize",
      "Sakarya",
      "Samsun",
      "Şanlıurfa",
      "Siirt",
      "Sinop",
      "Sivas",
      "Şırnak",
      "Tekirdağ",
      "Tokat",
      "Trabzon",
      "Tunceli",
      "Uşak",
      "Van",
      "Yalova",
      "Yozgat",
      "Zonguldak"
    ]
  },
  {
    "name": "Turkmenistan",
    "states": [
      "Ahal",
      "Ashgabat",
      "Balkan",
      "Daşoguz",
      "Lebap",
      "Mary"
    ]
  },
  {
    "name": "Turks and Caicos Islands",
    "states": [
      "Grand Turk",
      "Middle Caicos",
      "North Caicos",
      "Providenciales",
      "Salt Cay",
      "South Caicos"
    ]
  },
  {
    "name": "Tuvalu",
    "states": [
      "Funafuti",
      "Nanumanga",
      "Nanumea",
      "Niutao Island Council",
      "Nui",
      "Nukufetau",
      "Nukulaelae",
      "Vaitupu"
    ]
  },
  {
    "name": "Uganda",
    "states": [
      "Abim",
      "Adjumani",
      "Agago",
      "Alebtong",
      "Amolatar",
      "Amudat",
      "Amuria",
      "Amuru",
      "Apac",
      "Arua",
      "Budaka",
      "Bududa",
      "Bugiri",
      "Bugweri",
      "Buhweju",
      "Buikwe",
      "Bukedea",
      "Bukomansimbi",
      "Bukwo",
      "Bulambuli",
      "Buliisa",
      "Bundibugyo",
      "Bunyangabu",
      "Bushenyi",
      "Busia",
      "Butaleja",
      "Butambala",
      "Butebo",
      "Buvuma",
      "Buyende",
      "Central",
      "Dokolo",
      "Eastern",
      "Gomba",
      "Gulu",
      "Hoima",
      "Ibanda",
      "Iganga",
      "Isingiro",
      "Jinja",
      "Kaabong",
      "Kabale",
      "Kabarole",
      "Kaberamaido",
      "Kagadi",
      "Kakumiro",
      "Kalaki",
      "Kalangala",
      "Kaliro",
      "Kalungu",
      "Kampala",
      "Kamuli",
      "Kamwenge",
      "Kanungu",
      "Kapchorwa",
      "Kapelebyong",
      "Karenga",
      "Kasanda",
      "Kasese",
      "Katakwi",
      "Kayunga",
      "Kazo",
      "Kibaale",
      "Kiboga",
      "Kibuku",
      "Kikuube",
      "Kiruhura",
      "Kiryandongo",
      "Kisoro",
      "Kitagwenda",
      "Kitgum",
      "Koboko",
      "Kole",
      "Kotido",
      "Kumi",
      "Kwania",
      "Kween",
      "Kyankwanzi",
      "Kyegegwa",
      "Kyenjojo",
      "Kyotera",
      "Lamwo",
      "Lira",
      "Luuka",
      "Luwero",
      "Lwengo",
      "Lyantonde",
      "Madi-Okollo",
      "Manafwa",
      "Maracha",
      "Masaka",
      "Masindi",
      "Mayuge",
      "Mbale",
      "Mbarara",
      "Mitooma",
      "Mityana",
      "Moroto",
      "Moyo",
      "Mpigi",
      "Mubende",
      "Mukono",
      "Nabilatuk",
      "Nakapiripirit",
      "Nakaseke",
      "Nakasongola",
      "Namayingo",
      "Namisindwa",
      "Namutumba",
      "Napak",
      "Nebbi",
      "Ngora",
      "Northern",
      "Ntoroko",
      "Ntungamo",
      "Nwoya",
      "Obongi",
      "Omoro",
      "Otuke",
      "Oyam",
      "Pader",
      "Pakwach",
      "Pallisa",
      "Rakai",
      "Rubanda",
      "Rubirizi",
      "Rukiga",
      "Rukungiri",
      "Rwampara",
      "Sembabule",
      "Serere",
      "Sheema",
      "Sironko",
      "Soroti",
      "Tororo",
      "Wakiso",
      "Western",
      "Yumbe",
      "Zombo"
    ]
  },
  {
    "name": "Ukraine",
    "states": [
      "Autonomous Republic of Crimea",
      "Cherkaska",
      "Chernihivska",
      "Chernivetska",
      "Dnipropetrovska",
      "Donetska",
      "Ivano-Frankivska",
      "Kharkivska",
      "Khersonska",
      "Khmelnytska",
      "Kirovohradska",
      "Kyiv",
      "Kyivska",
      "Luhanska",
      "Lvivska",
      "Mykolaivska",
      "Odeska",
      "Poltavska",
      "Rivnenska",
      "Sevastopol",
      "Sumska",
      "Ternopilska",
      "Vinnytska",
      "Volynska",
      "Zakarpatska",
      "Zaporizka",
      "Zhytomyrska"
    ]
  },
  {
    "name": "United Arab Emirates",
    "states": [
      "Abu Dhabi",
      "Ajman",
      "Dubai",
      "Fujairah",
      "Ras Al Khaimah",
      "Sharjah",
      "Umm Al Quwain"
    ]
  },
  {
    "name": "United Kingdom",
    "states": [
      "Aberdeen",
      "Aberdeenshire",
      "Angus",
      "Antrim",
      "Antrim and Newtownabbey",
      "Ards",
      "Ards and North Down",
      "Argyll and Bute",
      "Armagh",
      "Armagh, Banbridge and Craigavon",
      "Ascension Island",
      "Ballymena",
      "Ballymoney",
      "Banbridge",
      "Barking and Dagenham",
      "Barnet",
      "Barnsley",
      "Bath and North East Somerset",
      "Bedford",
      "Belfast",
      "Bexley",
      "Birmingham",
      "Blackburn with Darwen",
      "Blackpool",
      "Blaenau Gwent",
      "Bolton",
      "Bournemouth",
      "Bracknell Forest",
      "Bradford",
      "Brent",
      "Bridgend",
      "Brighton and Hove",
      "Bristol",
      "Bromley",
      "Buckinghamshire",
      "Bury",
      "Caerphilly",
      "Calderdale",
      "Cambridgeshire",
      "Camden",
      "Cardiff",
      "Carmarthenshire",
      "Carrickfergus",
      "Castlereagh",
      "Causeway Coast and Glens",
      "Central Bedfordshire",
      "Ceredigion",
      "Cheshire East",
      "Cheshire West and Chester",
      "City of Kingston upon Hull",
      "City of Southampton",
      "Clackmannanshire",
      "Coleraine",
      "Conwy",
      "Cookstown",
      "Cornwall",
      "Coventry",
      "Craigavon",
      "Croydon",
      "Cumbria",
      "Darlington",
      "Denbighshire",
      "Derby",
      "Derbyshire",
      "Derry",
      "Derry City and Strabane",
      "Devon",
      "Doncaster",
      "Dorset",
      "Down District Council",
      "Dudley",
      "Dumfries and Galloway",
      "Dundee",
      "Dungannon and South Tyrone",
      "Durham",
      "Ealing",
      "East Ayrshire",
      "East Dunbartonshire",
      "East Lothian",
      "East Renfrewshire",
      "East Riding of Yorkshire",
      "East Sussex",
      "Edinburgh",
      "Enfield",
      "England",
      "Essex",
      "Falkirk",
      "Fermanagh",
      "Fermanagh and Omagh",
      "Fife",
      "Flintshire",
      "Gateshead",
      "Glasgow",
      "Gloucestershire",
      "Greenwich",
      "Gwynedd",
      "Hackney",
      "Halton",
      "Hammersmith and Fulham",
      "Hampshire",
      "Haringey",
      "Harrow",
      "Hartlepool",
      "Havering",
      "Herefordshire",
      "Hertfordshire",
      "Highland",
      "Hillingdon",
      "Hounslow",
      "Inverclyde",
      "Isle of Wight",
      "Isles of Scilly",
      "Islington",
      "Kensington and Chelsea",
      "Kent",
      "Kingston upon Thames",
      "Kirklees",
      "Knowsley",
      "Lambeth",
      "Lancashire",
      "Larne",
      "Leeds",
      "Leicester",
      "Leicestershire",
      "Lewisham",
      "Limavady",
      "Lincolnshire",
      "Lisburn",
      "Lisburn and Castlereagh",
      "Liverpool",
      "London",
      "Magherafelt",
      "Manchester",
      "Medway",
      "Merthyr Tydfil",
      "Merton",
      "Mid and East Antrim",
      "Mid Ulster",
      "Middlesbrough",
      "Midlothian",
      "Milton Keynes",
      "Monmouthshire",
      "Moray",
      "Moyle",
      "Neath Port Talbot",
      "Newcastle upon Tyne",
      "Newham",
      "Newport",
      "Newry and Mourne",
      "Newry, Mourne and Down",
      "Newtownabbey",
      "Norfolk",
      "North Ayrshire",
      "North Down",
      "North East Lincolnshire",
      "North Lanarkshire",
      "North Lincolnshire",
      "North Somerset",
      "North Tyneside",
      "North Yorkshire",
      "Northamptonshire",
      "Northern Ireland",
      "Northumberland",
      "Nottingham",
      "Nottinghamshire",
      "Oldham",
      "Omagh",
      "Orkney Islands",
      "Outer Hebrides",
      "Oxfordshire",
      "Pembrokeshire",
      "Perth and Kinross",
      "Peterborough",
      "Plymouth",
      "Poole",
      "Portsmouth",
      "Powys",
      "Reading",
      "Redbridge",
      "Redcar and Cleveland",
      "Renfrewshire",
      "Rhondda Cynon Taf",
      "Richmond upon Thames",
      "Rochdale",
      "Rotherham",
      "Rutland",
      "Saint Helena",
      "Salford",
      "Sandwell",
      "Scotland",
      "Scottish Borders",
      "Sefton",
      "Sheffield",
      "Shetland Islands",
      "Shropshire",
      "Slough",
      "Solihull",
      "Somerset",
      "South Ayrshire",
      "South Gloucestershire",
      "South Lanarkshire",
      "South Tyneside",
      "Southend-on-Sea",
      "Southwark",
      "St Helens",
      "Staffordshire",
      "Stirling",
      "Stockport",
      "Stockton-on-Tees",
      "Stoke-on-Trent",
      "Strabane",
      "Suffolk",
      "Sunderland",
      "Surrey",
      "Sutton",
      "Swansea",
      "Swindon",
      "Tameside",
      "Telford and Wrekin",
      "Thurrock",
      "Torbay",
      "Torfaen",
      "Tower Hamlets",
      "Trafford",
      "United Kingdom",
      "Vale of Glamorgan",
      "Wakefield",
      "Wales",
      "Walsall",
      "Waltham Forest",
      "Wandsworth",
      "Warrington",
      "Warwickshire",
      "West Berkshire",
      "West Dunbartonshire",
      "West Lothian",
      "West Sussex",
      "Westminster",
      "Wigan",
      "Wiltshire",
      "Windsor and Maidenhead",
      "Wirral",
      "Wokingham",
      "Wolverhampton",
      "Worcestershire",
      "Wrexham",
      "York"
    ]
  },
  {
    "name": "United States",
    "states": [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District of Columbia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "United States Minor Outlying Islands",
      "United States Virgin Islands",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming"
    ]
  },
  {
    "name": "United States Minor Outlying Islands",
    "states": [
      "Baker Island",
      "Howland Island",
      "Jarvis Island",
      "Johnston Atoll",
      "Kingman Reef",
      "Midway Islands",
      "Navassa Island",
      "Palmyra Atoll",
      "Wake Island"
    ]
  },
  {
    "name": "Uruguay",
    "states": [
      "Artigas",
      "Canelones",
      "Cerro Largo",
      "Colonia",
      "Durazno",
      "Flores",
      "Florida",
      "Lavalleja",
      "Maldonado",
      "Montevideo",
      "Paysandú",
      "Río Negro",
      "Rivera",
      "Rocha",
      "Salto",
      "San José",
      "Soriano",
      "Tacuarembó",
      "Treinta y Tres"
    ]
  },
  {
    "name": "Uzbekistan",
    "states": [
      "Andijan",
      "Bukhara",
      "Fergana",
      "Jizzakh",
      "Karakalpakstan",
      "Namangan",
      "Navoiy",
      "Qashqadaryo",
      "Samarqand",
      "Sirdaryo",
      "Surxondaryo",
      "Tashkent",
      "Tashkent",
      "Xorazm"
    ]
  },
  {
    "name": "Vanuatu",
    "states": [
      "Malampa",
      "Penama",
      "Sanma",
      "Shefa",
      "Tafea",
      "Torba"
    ]
  },
  {
    "name": "Vatican City State (Holy See)",
    "states": []
  },
  {
    "name": "Venezuela",
    "states": [
      "Amazonas",
      "Anzoátegui",
      "Apure",
      "Aragua",
      "Barinas",
      "Bolívar",
      "Carabobo",
      "Cojedes",
      "Delta Amacuro",
      "Distrito Capital",
      "Falcón",
      "Guárico",
      "La Guaira",
      "Lara",
      "Mérida",
      "Miranda",
      "Monagas",
      "Nueva Esparta",
      "Portuguesa",
      "Sucre",
      "Táchira",
      "Trujillo",
      "Venezuela",
      "Yaracuy",
      "Zulia"
    ]
  },
  {
    "name": "Vietnam",
    "states": [
      "An Giang",
      "Bắc Ninh",
      "Cà Mau",
      "Cần Thơ",
      "Cao Bằng",
      "Đà Nẵng",
      "Đắk Lắk",
      "Điện Biên",
      "Đồng Nai",
      "Đồng Tháp",
      "Gia Lai",
      "Hà Nội",
      "Hà Tĩnh",
      "Hải Phòng",
      "Hồ Chí Minh",
      "Hưng Yên",
      "Khánh Hòa",
      "Lai Châu",
      "Lâm Đồng",
      "Lạng Sơn",
      "Lào Cai",
      "Nghệ An",
      "Ninh Bình",
      "Phú Thọ",
      "Quảng Ngãi",
      "Quảng Ninh",
      "Quảng Trị",
      "Sơn La",
      "Tây Ninh",
      "Thái Nguyên",
      "Thanh Hóa",
      "Thừa Thiên-Huế",
      "Tuyên Quang",
      "Vĩnh Long"
    ]
  },
  {
    "name": "Virgin Islands (British)",
    "states": []
  },
  {
    "name": "Virgin Islands (US)",
    "states": [
      "Saint Croix",
      "Saint John",
      "Saint Thomas"
    ]
  },
  {
    "name": "Wallis and Futuna Islands",
    "states": []
  },
  {
    "name": "Western Sahara",
    "states": []
  },
  {
    "name": "Yemen",
    "states": [
      "'Adan",
      "'Amran",
      "Abyan",
      "Al Bayda'",
      "Al Hudaydah",
      "Al Jawf",
      "Al Mahrah",
      "Al Mahwit",
      "Amanat Al Asimah",
      "Dhamar",
      "Hadhramaut",
      "Hajjah",
      "Ibb",
      "Lahij",
      "Ma'rib",
      "Raymah",
      "Saada",
      "Sana'a",
      "Shabwah",
      "Socotra",
      "Ta'izz"
    ]
  },
  {
    "name": "Zambia",
    "states": [
      "Central",
      "Copperbelt",
      "Eastern",
      "Luapula",
      "Lusaka",
      "Muchinga",
      "Northern",
      "Northwestern",
      "Southern",
      "Western"
    ]
  },
  {
    "name": "Zimbabwe",
    "states": [
      "Bulawayo",
      "Harare",
      "Manicaland",
      "Mashonaland Central",
      "Mashonaland East",
      "Mashonaland West",
      "Masvingo",
      "Matabeleland North",
      "Matabeleland South",
      "Midlands"
    ]
  }
];
